(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["adhd-planner-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    if (window.CovaHeroGallery) return;

    function initGallery(root) {
      if (root.dataset.covaGalleryInit) return;
      var track = root.querySelector('[data-cova-gallery-track]');
      var list = root.querySelector('[data-cova-gallery-list]');
      var wrap = root.querySelector('[data-cova-gallery-thumbs]');
      if (!track || !list || !wrap) return;
      root.dataset.covaGalleryInit = '1';
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-cova-gallery-thumb]'));
      var clamp = root.hasAttribute('data-cova-gallery-clamp');
      var reduce = false;
      try {
        reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) {}
      var active = -1;
      var raf = 0;

      function pitch() {
        if (thumbs.length > 1) return thumbs[1].parentElement.offsetTop - thumbs[0].parentElement.offsetTop;
        return thumbs[0] ? thumbs[0].offsetHeight : 0;
      }
      function update() {
        raf = 0;
        var w = track.clientWidth || 1;
        var count = thumbs.length;
        var p = Math.max(0, Math.min(count - 1, track.scrollLeft / w));
        var shift = p * pitch();
        if (clamp) shift = Math.min(shift, Math.max(0, list.offsetHeight - wrap.clientHeight));
        list.style.transform = 'translate3d(0,' + -shift.toFixed(2) + 'px,0)';
        var i = Math.round(p);
        if (i !== active) {
          active = i;
          thumbs.forEach(function (t, n) {
            var on = n === i;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-current', on ? 'true' : 'false');
          });
        }
      }
      function queue() {
        if (!raf) raf = window.requestAnimationFrame(update);
      }
      function goTo(i) {
        track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      }

      track.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue);
      thumbs.forEach(function (t, n) {
        t.addEventListener('click', function () {
          goTo(n);
        });
      });
      if (window.ResizeObserver) new window.ResizeObserver(queue).observe(root);
      update();
    }

    function init(scope) {
      (scope || document).querySelectorAll('[data-cova-gallery]').forEach(initGallery);
    }
    window.CovaHeroGallery = { init: init };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adhd-planner-problem-checklist"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    if (window.CovaTicksInit) return;
    window.CovaTicksInit = true;
    var reduce = false;
    try {
      reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {}

    function arm(root) {
      var lists = (root || document).querySelectorAll('[data-cova-ticks]');
      Array.prototype.forEach.call(lists, function (list) {
        if (list.getAttribute('data-cova-ticks-state')) return;
        list.setAttribute('data-cova-ticks-state', 'armed');
        if (reduce || !('IntersectionObserver' in window)) return;
        var items = list.querySelectorAll('.cova-problem-checklist__item');
        list.classList.add('is-armed');
        var io = new IntersectionObserver(
          function (entries) {
            for (var i = 0; i < entries.length; i++) {
              if (!entries[i].isIntersecting) continue;
              io.disconnect();
              Array.prototype.forEach.call(items, function (item, n) {
                window.setTimeout(function () {
                  item.classList.add('is-ticked');
                }, 450 + n * 520);
              });
              break;
            }
          },
          { threshold: 0.6 }
        );
        io.observe(list);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { arm(); });
    else arm();
    document.addEventListener('shopify:section:load', function (e) { arm(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adhd-planner-proven-stats"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.CovaStatsCountInit) return;
    window.CovaStatsCountInit = true;

    var DURATION = 1400; // ms, ease-out
    var STAGGER = 140; // ms between the cards
    var reduceMq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    function esc(t) {
      return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    // "93%" -> prefix "", number "93", suffix "%". Anything else (no number, thousands separators) stays as is.
    function parse(text) {
      var m = /^(\D*?)(\d+(?:\.\d+)?)(\D*)$/.exec(text);
      if (!m) return null;
      var dot = m[2].indexOf('.');
      return { pre: m[1], post: m[3], value: parseFloat(m[2]), decimals: dot < 0 ? 0 : m[2].length - dot - 1 };
    }

    // Pin the box to the width of the final text (so nothing around it can move), then show the start value.
    function prepare(el) {
      var finalText = el.textContent.trim();
      var info = parse(finalText);
      if (!info) return null;
      el.style.minWidth = Math.ceil(el.getBoundingClientRect().width * 100) / 100 + 'px';
      el.innerHTML = '<span class="cova-visually-hidden">' + esc(finalText) + '</span><span aria-hidden="true"></span>';
      var job = { el: el, text: el.lastChild, finalText: finalText, info: info };
      show(job, 0);
      return job;
    }

    function show(job, value) {
      job.text.textContent = job.info.pre + value.toFixed(job.info.decimals) + job.info.post;
    }

    function run(jobs) {
      var t0 = null;
      function frame(now) {
        if (t0 === null) t0 = now;
        var running = false;
        for (var i = 0; i < jobs.length; i++) {
          var job = jobs[i];
          if (job.done) continue;
          var p = (now - t0 - i * STAGGER) / DURATION;
          if (p >= 1) {
            job.done = true;
            job.el.textContent = job.finalText; // the text exactly as authored in the setting
            continue;
          }
          running = true;
          p = p < 0 ? 0 : p;
          show(job, job.info.value * (1 - Math.pow(1 - p, 3)));
        }
        if (running) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    function arm(root) {
      var sections = (root || document).querySelectorAll('[data-cova-proven-stats]');
      Array.prototype.forEach.call(sections, function (section) {
        if (section.getAttribute('data-cova-count-state')) return;
        section.setAttribute('data-cova-count-state', 'armed');
        if ((reduceMq && reduceMq.matches) || !('IntersectionObserver' in window)) return;
        var els = section.querySelectorAll('[data-cova-count]');
        if (!els.length) return;
        var fontsReady = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
        var jobs = null;
        var seen = false;
        fontsReady.then(function () {
          // measure once the font is loaded, then park every number at 0 until the section is seen
          jobs = [];
          Array.prototype.forEach.call(els, function (el) {
            var job = prepare(el);
            if (job) jobs.push(job);
          });
          if (seen && jobs.length) run(jobs);
        });
        var io = new IntersectionObserver(
          function (entries) {
            for (var i = 0; i < entries.length; i++) {
              if (!entries[i].isIntersecting) continue;
              io.disconnect();
              seen = true;
              if (jobs && jobs.length) run(jobs);
              break;
            }
          },
          { threshold: 0.3 }
        );
        io.observe(section);
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { arm(); });
    else arm();
    document.addEventListener('shopify:section:load', function (e) { arm(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adhd-planner-scratch-popup"]) return;
  try {
    
  (function () {
    'use strict';
    if (window.CovaPopup) {
      window.CovaPopup.init(document);
      return;
    }

    var SEEN_KEY = 'cova:popup-seen';
    var BRUSH = 46; // scratch brush width in CSS px
    var THRESHOLD = 0.5; // share of the coating that has to go before the prize is revealed
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    function storageGet(key) {
      try {
        return window.localStorage.getItem(key);
      } catch (e) {
        return null;
      }
    }
    function storageSet(key, value) {
      try {
        window.localStorage.setItem(key, value);
      } catch (e) {}
    }
    function blocked() {
      var html = document.documentElement;
      return html.hasAttribute('data-cova-no-popup') || (document.body && document.body.hasAttribute('data-cova-no-popup'));
    }
    function designMode() {
      return !!(window.Shopify && window.Shopify.designMode);
    }
    function q(root, name) {
      return root.querySelector('[data-cova-popup-' + name + ']');
    }
    function reduceMotion() {
      try {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) {
        return false;
      }
    }

    /* ---------------------------------------------------------------- gold coating */
    function roundRect(ctx, x, y, w, h, r) {
      ctx.beginPath();
      ctx.moveTo(x + r, y);
      ctx.arcTo(x + w, y, x + w, y + h, r);
      ctx.arcTo(x + w, y + h, x, y + h, r);
      ctx.arcTo(x, y + h, x, y, r);
      ctx.arcTo(x, y, x + w, y, r);
      ctx.closePath();
    }

    function paintCoating(ctx, w, h, label) {
      ctx.globalCompositeOperation = 'source-over';
      var g = ctx.createLinearGradient(0, 0, w, h);
      g.addColorStop(0, '#f6d982');
      g.addColorStop(0.28, '#e4bc5d');
      g.addColorStop(0.5, '#f3d47c');
      g.addColorStop(0.74, '#d6aa45');
      g.addColorStop(1, '#ebc869');
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, w, h);

      // soft light sweep, like foil catching light
      var sweep = ctx.createLinearGradient(0, h * 0.15, w, h * 0.05);
      sweep.addColorStop(0, 'rgba(255,255,255,0)');
      sweep.addColorStop(0.5, 'rgba(255,255,255,0.22)');
      sweep.addColorStop(1, 'rgba(255,255,255,0)');
      ctx.fillStyle = sweep;
      ctx.fillRect(0, 0, w, h * 0.6);

      // fine grain
      var specks = Math.round((w * h) / 48);
      for (var i = 0; i < specks; i++) {
        var x = Math.random() * w;
        var y = Math.random() * h;
        var dark = Math.random() < 0.45;
        ctx.fillStyle = dark ? 'rgba(120,86,20,' + (0.04 + Math.random() * 0.1) + ')' : 'rgba(255,248,214,' + (0.08 + Math.random() * 0.2) + ')';
        var s = 0.5 + Math.random() * 1.3;
        ctx.fillRect(x, y, s, s);
      }

      // darker brush strokes behind the label
      ctx.save();
      ctx.globalAlpha = 0.17;
      ctx.fillStyle = '#6d5220';
      for (var k = 0; k < 5; k++) {
        ctx.save();
        ctx.translate(w * (0.2 + 0.15 * k), h * 0.56);
        ctx.rotate(-0.3);
        roundRect(ctx, -w * 0.045, -h * 0.27, w * 0.095, h * 0.54, w * 0.02);
        ctx.fill();
        ctx.restore();
      }
      ctx.restore();

      // label
      var size = Math.min(36, w * 0.105);
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      var family = 'Figtree, system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif';
      ctx.font = '800 ' + size + 'px ' + family;
      while (size > 14 && ctx.measureText(label).width > w * 0.84) {
        size -= 1;
        ctx.font = '800 ' + size + 'px ' + family;
      }
      ctx.save();
      ctx.shadowColor = 'rgba(110,80,20,0.35)';
      ctx.shadowBlur = 3;
      ctx.shadowOffsetY = 1;
      ctx.fillStyle = 'rgba(255,250,232,0.66)';
      ctx.fillText(label, w / 2, h / 2 + 1);
      ctx.restore();
    }

    /* ---------------------------------------------------------------- one popup */
    function setup(root) {
      if (root.covaPopup) return;
      var card = q(root, 'card');
      var canvas = q(root, 'canvas');
      var reveal = q(root, 'reveal');
      var claimBtn = q(root, 'claim');
      var form = q(root, 'form');
      var email = q(root, 'email');
      var errorLine = q(root, 'error-line');
      var success = q(root, 'success');
      var closeBtn = q(root, 'close');
      if (!card || !canvas || !closeBtn) return;

      var delay = parseFloat(root.getAttribute('data-cova-popup-delay'));
      if (isNaN(delay) || delay < 0) delay = 10;
      var amount = root.getAttribute('data-cova-popup-amount') || '';
      var errorText = root.getAttribute('data-cova-popup-error') || '';
      var closeLabel = root.getAttribute('data-cova-popup-close-label') || '';
      var label = canvas.getAttribute('data-cova-popup-label') || '';
      var ctx = canvas.getContext ? canvas.getContext('2d', { willReadFrequently: true }) : null;

      var st = { open: false, done: false, touched: false, drawing: false, last: null, lastCheck: 0, w: 0, h: 0, dpr: 1, timer: 0, prevFocus: null, claimed: false };

      function prepare() {
        if (!ctx) {
          finish();
          return;
        }
        var rect = card.getBoundingClientRect();
        if (!rect.width) return;
        st.dpr = Math.min(window.devicePixelRatio || 1, 2);
        st.w = Math.round(rect.width);
        st.h = Math.round(rect.height);
        canvas.width = Math.round(st.w * st.dpr);
        canvas.height = Math.round(st.h * st.dpr);
        ctx.setTransform(st.dpr, 0, 0, st.dpr, 0, 0);
        ctx.clearRect(0, 0, st.w, st.h);
        paintCoating(ctx, st.w, st.h, label);
        st.touched = false;
      }

      function point(e) {
        var r = canvas.getBoundingClientRect();
        return { x: ((e.clientX - r.left) / r.width) * st.w, y: ((e.clientY - r.top) / r.height) * st.h };
      }
      function stroke(from, to) {
        ctx.globalCompositeOperation = 'destination-out';
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.lineWidth = BRUSH;
        ctx.beginPath();
        ctx.moveTo(from.x, from.y);
        ctx.lineTo(to.x, to.y);
        ctx.stroke();
        ctx.globalCompositeOperation = 'source-over';
      }
      function cleared() {
        var cw = canvas.width;
        var ch = canvas.height;
        var data;
        try {
          data = ctx.getImageData(0, 0, cw, ch).data;
        } catch (e) {
          return 0;
        }
        var step = Math.max(4, Math.round(st.dpr * 4));
        var total = 0;
        var gone = 0;
        for (var y = 0; y < ch; y += step) {
          for (var x = 0; x < cw; x += step) {
            total++;
            if (data[(y * cw + x) * 4 + 3] < 40) gone++;
          }
        }
        return total ? gone / total : 0;
      }
      function check() {
        st.lastCheck = Date.now();
        if (!st.done && cleared() >= THRESHOLD) finish();
      }

      function finish() {
        if (st.done) return;
        st.done = true;
        st.drawing = false;
        canvas.classList.add('is-cleared');
        canvas.setAttribute('aria-hidden', 'true');
        canvas.tabIndex = -1;
        if (reveal) {
          reveal.hidden = false;
          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
              reveal.classList.add('is-shown');
            });
          });
        }
      }

      canvas.addEventListener('pointerdown', function (e) {
        if (st.done || !ctx) return;
        e.preventDefault();
        try {
          canvas.setPointerCapture(e.pointerId);
        } catch (err) {}
        st.drawing = true;
        st.touched = true;
        st.last = point(e);
        stroke(st.last, st.last);
      });
      canvas.addEventListener('pointermove', function (e) {
        if (!st.drawing || st.done) return;
        e.preventDefault();
        var p = point(e);
        stroke(st.last, p);
        st.last = p;
        if (Date.now() - st.lastCheck > 90) check();
      });
      function stop() {
        if (!st.drawing) return;
        st.drawing = false;
        check();
      }
      canvas.addEventListener('pointerup', stop);
      canvas.addEventListener('pointercancel', stop);
      canvas.addEventListener('lostpointercapture', stop);
      canvas.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (ctx) ctx.clearRect(0, 0, st.w, st.h);
          finish();
        }
      });

      if (claimBtn && form) {
        claimBtn.addEventListener('click', function () {
          claimBtn.hidden = true;
          form.hidden = false;
          if (email) email.focus();
        });
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var value = (email ? email.value : '').trim();
          if (!EMAIL_RE.test(value)) {
            if (errorLine) {
              errorLine.textContent = errorText;
              errorLine.hidden = false;
            }
            if (email) {
              email.setAttribute('aria-invalid', 'true');
              email.focus();
            }
            return;
          }
          if (errorLine) errorLine.hidden = true;
          if (email) email.removeAttribute('aria-invalid');
          st.claimed = true;
          form.hidden = true;
          if (success) success.hidden = false;
          if (closeLabel) closeBtn.textContent = closeLabel;
          // The email is sent by a separate integration that listens for this event.
          root.dispatchEvent(new CustomEvent('cova:discount-claimed', { bubbles: true, detail: { email: value, discount: amount, source: 'scratch-popup' } }));
        });
        if (email) {
          email.addEventListener('input', function () {
            if (errorLine) errorLine.hidden = true;
            email.removeAttribute('aria-invalid');
          });
        }
      }

      function focusables() {
        return Array.prototype.slice.call(root.querySelectorAll('button, input, [tabindex="0"]')).filter(function (el) {
          return !el.disabled && !el.hidden && !el.closest('[hidden]') && el.getAttribute('aria-hidden') !== 'true' && el.tabIndex >= 0;
        });
      }
      function onKey(e) {
        if (!st.open) return;
        if (e.key === 'Escape') {
          e.preventDefault();
          close();
          return;
        }
        if (e.key !== 'Tab') return;
        var list = focusables();
        if (!list.length) return;
        var first = list[0];
        var last = list[list.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === root)) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
      var resizeRaf = 0;
      function onResize() {
        if (!st.open || st.touched || st.done) return;
        if (resizeRaf) return;
        resizeRaf = window.requestAnimationFrame(function () {
          resizeRaf = 0;
          prepare();
        });
      }

      function open(opts) {
        if (st.open) return;
        opts = opts || {};
        st.open = true;
        window.clearTimeout(st.timer);
        st.prevFocus = document.activeElement;
        root.hidden = false;
        document.documentElement.classList.add('cova-popup-lock');
        if (!opts.preview) storageSet(SEEN_KEY, '1');
        // make sure the label font is ready before the coating is painted
        var ready = document.fonts && document.fonts.load ? document.fonts.load('800 36px Figtree') : null;
        var go = function () {
          if (st.open && !st.touched && !st.done) prepare();
        };
        prepare();
        if (ready && ready.then) ready.then(go, go);
        window.requestAnimationFrame(function () {
          root.classList.add('is-open');
        });
        try {
          root.focus({ preventScroll: true });
        } catch (e) {
          root.focus();
        }
        document.addEventListener('keydown', onKey);
        window.addEventListener('resize', onResize);
        root.dispatchEvent(new CustomEvent('cova:popup-open', { bubbles: true }));
      }

      function close() {
        if (!st.open) return;
        st.open = false;
        root.classList.remove('is-open');
        document.removeEventListener('keydown', onKey);
        window.removeEventListener('resize', onResize);
        var hide = function () {
          if (st.open) return;
          root.hidden = true;
          document.documentElement.classList.remove('cova-popup-lock');
        };
        if (reduceMotion()) hide();
        else window.setTimeout(hide, 360);
        var back = st.prevFocus;
        if (back && back.focus && document.contains(back)) {
          try {
            back.focus({ preventScroll: true });
          } catch (e) {}
        }
        root.dispatchEvent(new CustomEvent('cova:popup-close', { bubbles: true, detail: { claimed: st.claimed } }));
      }

      closeBtn.addEventListener('click', close);

      function schedule() {
        if (designMode()) return; // in the theme editor the popup opens when the section is selected
        if (blocked() || storageGet(SEEN_KEY)) return;
        st.timer = window.setTimeout(function () {
          if (blocked() || storageGet(SEEN_KEY)) return;
          open();
        }, delay * 1000);
      }
      schedule();

      root.covaPopup = { open: open, close: close };
    }

    function init(scope) {
      var list = (scope || document).querySelectorAll('[data-cova-popup]');
      for (var i = 0; i < list.length; i++) setup(list[i]);
    }

    window.CovaPopup = { init: init };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:section:select', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('[data-cova-popup]') : null;
      if (root && root.covaPopup) root.covaPopup.open({ preview: true });
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('[data-cova-popup]') : null;
      if (root && root.covaPopup) root.covaPopup.close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adhd-planner-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.CovaVideoInit) return;
    window.CovaVideoInit = true;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-cova-video-play]') : null;
      if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
      var frame = btn.closest('[data-cova-video]');
      if (!frame) return;
      var video = frame.querySelector('video');
      var embed = frame.getAttribute('data-embed');
      if (video) {
        video.controls = true;
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
        frame.classList.add('is-playing');
      } else if (embed) {
        var stage = frame.querySelector('[data-cova-video-stage]');
        if (!stage) return;
        var frameEl = document.createElement('iframe');
        frameEl.src = embed;
        frameEl.allow = 'autoplay; fullscreen; picture-in-picture';
        frameEl.setAttribute('allowfullscreen', '');
        frameEl.title = btn.getAttribute('aria-label') || 'Video';
        stage.appendChild(frameEl);
        frame.classList.add('is-playing');
      }
    });

    // when a video ends, show the poster and play button again
    document.addEventListener(
      'ended',
      function (e) {
        var frame = e.target.closest ? e.target.closest('[data-cova-video]') : null;
        if (!frame) return;
        e.target.controls = false;
        frame.classList.remove('is-playing');
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boxing-band-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    if (window.CovaHeroGallery) return;

    function initGallery(root) {
      if (root.dataset.covaGalleryInit) return;
      var track = root.querySelector('[data-cova-gallery-track]');
      var list = root.querySelector('[data-cova-gallery-list]');
      var wrap = root.querySelector('[data-cova-gallery-thumbs]');
      if (!track || !list || !wrap) return;
      root.dataset.covaGalleryInit = '1';
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-cova-gallery-thumb]'));
      var clamp = root.hasAttribute('data-cova-gallery-clamp');
      var reduce = false;
      try {
        reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) {}
      var active = -1;
      var raf = 0;

      function pitch() {
        if (thumbs.length > 1) return thumbs[1].parentElement.offsetTop - thumbs[0].parentElement.offsetTop;
        return thumbs[0] ? thumbs[0].offsetHeight : 0;
      }
      function update() {
        raf = 0;
        var w = track.clientWidth || 1;
        var count = thumbs.length;
        var p = Math.max(0, Math.min(count - 1, track.scrollLeft / w));
        var shift = p * pitch();
        if (clamp) shift = Math.min(shift, Math.max(0, list.offsetHeight - wrap.clientHeight));
        list.style.transform = 'translate3d(0,' + -shift.toFixed(2) + 'px,0)';
        var i = Math.round(p);
        if (i !== active) {
          active = i;
          thumbs.forEach(function (t, n) {
            var on = n === i;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-current', on ? 'true' : 'false');
          });
        }
      }
      function queue() {
        if (!raf) raf = window.requestAnimationFrame(update);
      }
      function goTo(i) {
        track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      }

      track.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue);
      thumbs.forEach(function (t, n) {
        t.addEventListener('click', function () {
          goTo(n);
        });
      });
      if (window.ResizeObserver) new window.ResizeObserver(queue).observe(root);
      update();
    }

    function init(scope) {
      (scope || document).querySelectorAll('[data-cova-gallery]').forEach(initGallery);
    }
    window.CovaHeroGallery = { init: init };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boxing-band-proven-stats"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.CovaStatsCountInit) return;
    window.CovaStatsCountInit = true;

    var DURATION = 1400; // ms, ease-out
    var STAGGER = 140; // ms between the cards
    var reduceMq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    function esc(t) {
      return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    // "93%" -> prefix "", number "93", suffix "%". Anything else (no number, thousands separators) stays as is.
    function parse(text) {
      var m = /^(\D*?)(\d+(?:\.\d+)?)(\D*)$/.exec(text);
      if (!m) return null;
      var dot = m[2].indexOf('.');
      return { pre: m[1], post: m[3], value: parseFloat(m[2]), decimals: dot < 0 ? 0 : m[2].length - dot - 1 };
    }

    // Pin the box to the width of the final text (so nothing around it can move), then show the start value.
    function prepare(el) {
      var finalText = el.textContent.trim();
      var info = parse(finalText);
      if (!info) return null;
      el.style.minWidth = Math.ceil(el.getBoundingClientRect().width * 100) / 100 + 'px';
      el.innerHTML = '<span class="cova-visually-hidden">' + esc(finalText) + '</span><span aria-hidden="true"></span>';
      var job = { el: el, text: el.lastChild, finalText: finalText, info: info };
      show(job, 0);
      return job;
    }

    function show(job, value) {
      job.text.textContent = job.info.pre + value.toFixed(job.info.decimals) + job.info.post;
    }

    function run(jobs) {
      var t0 = null;
      function frame(now) {
        if (t0 === null) t0 = now;
        var running = false;
        for (var i = 0; i < jobs.length; i++) {
          var job = jobs[i];
          if (job.done) continue;
          var p = (now - t0 - i * STAGGER) / DURATION;
          if (p >= 1) {
            job.done = true;
            job.el.textContent = job.finalText; // the text exactly as authored in the setting
            continue;
          }
          running = true;
          p = p < 0 ? 0 : p;
          show(job, job.info.value * (1 - Math.pow(1 - p, 3)));
        }
        if (running) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    function arm(root) {
      var sections = (root || document).querySelectorAll('[data-cova-proven-stats]');
      Array.prototype.forEach.call(sections, function (section) {
        if (section.getAttribute('data-cova-count-state')) return;
        section.setAttribute('data-cova-count-state', 'armed');
        if ((reduceMq && reduceMq.matches) || !('IntersectionObserver' in window)) return;
        var els = section.querySelectorAll('[data-cova-count]');
        if (!els.length) return;
        var fontsReady = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
        var jobs = null;
        var seen = false;
        fontsReady.then(function () {
          // measure once the font is loaded, then park every number at 0 until the section is seen
          jobs = [];
          Array.prototype.forEach.call(els, function (el) {
            var job = prepare(el);
            if (job) jobs.push(job);
          });
          if (seen && jobs.length) run(jobs);
        });
        var io = new IntersectionObserver(
          function (entries) {
            for (var i = 0; i < entries.length; i++) {
              if (!entries[i].isIntersecting) continue;
              io.disconnect();
              seen = true;
              if (jobs && jobs.length) run(jobs);
              break;
            }
          },
          { threshold: 0.3 }
        );
        io.observe(section);
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { arm(); });
    else arm();
    document.addEventListener('shopify:section:load', function (e) { arm(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boxing-band-scratch-popup"]) return;
  try {
    
  (function () {
    'use strict';
    if (window.CovaPopup) {
      window.CovaPopup.init(document);
      return;
    }

    var SEEN_KEY = 'cova:popup-seen';
    var BRUSH = 46; // scratch brush width in CSS px
    var THRESHOLD = 0.5; // share of the coating that has to go before the prize is revealed
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    function storageGet(key) {
      try {
        return window.localStorage.getItem(key);
      } catch (e) {
        return null;
      }
    }
    function storageSet(key, value) {
      try {
        window.localStorage.setItem(key, value);
      } catch (e) {}
    }
    function blocked() {
      var html = document.documentElement;
      return html.hasAttribute('data-cova-no-popup') || (document.body && document.body.hasAttribute('data-cova-no-popup'));
    }
    function designMode() {
      return !!(window.Shopify && window.Shopify.designMode);
    }
    function q(root, name) {
      return root.querySelector('[data-cova-popup-' + name + ']');
    }
    function reduceMotion() {
      try {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) {
        return false;
      }
    }

    /* ---------------------------------------------------------------- gold coating */
    function roundRect(ctx, x, y, w, h, r) {
      ctx.beginPath();
      ctx.moveTo(x + r, y);
      ctx.arcTo(x + w, y, x + w, y + h, r);
      ctx.arcTo(x + w, y + h, x, y + h, r);
      ctx.arcTo(x, y + h, x, y, r);
      ctx.arcTo(x, y, x + w, y, r);
      ctx.closePath();
    }

    function paintCoating(ctx, w, h, label) {
      ctx.globalCompositeOperation = 'source-over';
      var g = ctx.createLinearGradient(0, 0, w, h);
      g.addColorStop(0, '#f6d982');
      g.addColorStop(0.28, '#e4bc5d');
      g.addColorStop(0.5, '#f3d47c');
      g.addColorStop(0.74, '#d6aa45');
      g.addColorStop(1, '#ebc869');
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, w, h);

      // soft light sweep, like foil catching light
      var sweep = ctx.createLinearGradient(0, h * 0.15, w, h * 0.05);
      sweep.addColorStop(0, 'rgba(255,255,255,0)');
      sweep.addColorStop(0.5, 'rgba(255,255,255,0.22)');
      sweep.addColorStop(1, 'rgba(255,255,255,0)');
      ctx.fillStyle = sweep;
      ctx.fillRect(0, 0, w, h * 0.6);

      // fine grain
      var specks = Math.round((w * h) / 48);
      for (var i = 0; i < specks; i++) {
        var x = Math.random() * w;
        var y = Math.random() * h;
        var dark = Math.random() < 0.45;
        ctx.fillStyle = dark ? 'rgba(120,86,20,' + (0.04 + Math.random() * 0.1) + ')' : 'rgba(255,248,214,' + (0.08 + Math.random() * 0.2) + ')';
        var s = 0.5 + Math.random() * 1.3;
        ctx.fillRect(x, y, s, s);
      }

      // darker brush strokes behind the label
      ctx.save();
      ctx.globalAlpha = 0.17;
      ctx.fillStyle = '#6d5220';
      for (var k = 0; k < 5; k++) {
        ctx.save();
        ctx.translate(w * (0.2 + 0.15 * k), h * 0.56);
        ctx.rotate(-0.3);
        roundRect(ctx, -w * 0.045, -h * 0.27, w * 0.095, h * 0.54, w * 0.02);
        ctx.fill();
        ctx.restore();
      }
      ctx.restore();

      // label
      var size = Math.min(36, w * 0.105);
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      var family = 'Figtree, system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif';
      ctx.font = '800 ' + size + 'px ' + family;
      while (size > 14 && ctx.measureText(label).width > w * 0.84) {
        size -= 1;
        ctx.font = '800 ' + size + 'px ' + family;
      }
      ctx.save();
      ctx.shadowColor = 'rgba(110,80,20,0.35)';
      ctx.shadowBlur = 3;
      ctx.shadowOffsetY = 1;
      ctx.fillStyle = 'rgba(255,250,232,0.66)';
      ctx.fillText(label, w / 2, h / 2 + 1);
      ctx.restore();
    }

    /* ---------------------------------------------------------------- one popup */
    function setup(root) {
      if (root.covaPopup) return;
      var card = q(root, 'card');
      var canvas = q(root, 'canvas');
      var reveal = q(root, 'reveal');
      var claimBtn = q(root, 'claim');
      var form = q(root, 'form');
      var email = q(root, 'email');
      var errorLine = q(root, 'error-line');
      var success = q(root, 'success');
      var closeBtn = q(root, 'close');
      if (!card || !canvas || !closeBtn) return;

      var delay = parseFloat(root.getAttribute('data-cova-popup-delay'));
      if (isNaN(delay) || delay < 0) delay = 10;
      var amount = root.getAttribute('data-cova-popup-amount') || '';
      var errorText = root.getAttribute('data-cova-popup-error') || '';
      var closeLabel = root.getAttribute('data-cova-popup-close-label') || '';
      var label = canvas.getAttribute('data-cova-popup-label') || '';
      var ctx = canvas.getContext ? canvas.getContext('2d', { willReadFrequently: true }) : null;

      var st = { open: false, done: false, touched: false, drawing: false, last: null, lastCheck: 0, w: 0, h: 0, dpr: 1, timer: 0, prevFocus: null, claimed: false };

      function prepare() {
        if (!ctx) {
          finish();
          return;
        }
        var rect = card.getBoundingClientRect();
        if (!rect.width) return;
        st.dpr = Math.min(window.devicePixelRatio || 1, 2);
        st.w = Math.round(rect.width);
        st.h = Math.round(rect.height);
        canvas.width = Math.round(st.w * st.dpr);
        canvas.height = Math.round(st.h * st.dpr);
        ctx.setTransform(st.dpr, 0, 0, st.dpr, 0, 0);
        ctx.clearRect(0, 0, st.w, st.h);
        paintCoating(ctx, st.w, st.h, label);
        st.touched = false;
      }

      function point(e) {
        var r = canvas.getBoundingClientRect();
        return { x: ((e.clientX - r.left) / r.width) * st.w, y: ((e.clientY - r.top) / r.height) * st.h };
      }
      function stroke(from, to) {
        ctx.globalCompositeOperation = 'destination-out';
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.lineWidth = BRUSH;
        ctx.beginPath();
        ctx.moveTo(from.x, from.y);
        ctx.lineTo(to.x, to.y);
        ctx.stroke();
        ctx.globalCompositeOperation = 'source-over';
      }
      function cleared() {
        var cw = canvas.width;
        var ch = canvas.height;
        var data;
        try {
          data = ctx.getImageData(0, 0, cw, ch).data;
        } catch (e) {
          return 0;
        }
        var step = Math.max(4, Math.round(st.dpr * 4));
        var total = 0;
        var gone = 0;
        for (var y = 0; y < ch; y += step) {
          for (var x = 0; x < cw; x += step) {
            total++;
            if (data[(y * cw + x) * 4 + 3] < 40) gone++;
          }
        }
        return total ? gone / total : 0;
      }
      function check() {
        st.lastCheck = Date.now();
        if (!st.done && cleared() >= THRESHOLD) finish();
      }

      function finish() {
        if (st.done) return;
        st.done = true;
        st.drawing = false;
        canvas.classList.add('is-cleared');
        canvas.setAttribute('aria-hidden', 'true');
        canvas.tabIndex = -1;
        if (reveal) {
          reveal.hidden = false;
          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
              reveal.classList.add('is-shown');
            });
          });
        }
      }

      canvas.addEventListener('pointerdown', function (e) {
        if (st.done || !ctx) return;
        e.preventDefault();
        try {
          canvas.setPointerCapture(e.pointerId);
        } catch (err) {}
        st.drawing = true;
        st.touched = true;
        st.last = point(e);
        stroke(st.last, st.last);
      });
      canvas.addEventListener('pointermove', function (e) {
        if (!st.drawing || st.done) return;
        e.preventDefault();
        var p = point(e);
        stroke(st.last, p);
        st.last = p;
        if (Date.now() - st.lastCheck > 90) check();
      });
      function stop() {
        if (!st.drawing) return;
        st.drawing = false;
        check();
      }
      canvas.addEventListener('pointerup', stop);
      canvas.addEventListener('pointercancel', stop);
      canvas.addEventListener('lostpointercapture', stop);
      canvas.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (ctx) ctx.clearRect(0, 0, st.w, st.h);
          finish();
        }
      });

      if (claimBtn && form) {
        claimBtn.addEventListener('click', function () {
          claimBtn.hidden = true;
          form.hidden = false;
          if (email) email.focus();
        });
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var value = (email ? email.value : '').trim();
          if (!EMAIL_RE.test(value)) {
            if (errorLine) {
              errorLine.textContent = errorText;
              errorLine.hidden = false;
            }
            if (email) {
              email.setAttribute('aria-invalid', 'true');
              email.focus();
            }
            return;
          }
          if (errorLine) errorLine.hidden = true;
          if (email) email.removeAttribute('aria-invalid');
          st.claimed = true;
          form.hidden = true;
          if (success) success.hidden = false;
          if (closeLabel) closeBtn.textContent = closeLabel;
          // The email is sent by a separate integration that listens for this event.
          root.dispatchEvent(new CustomEvent('cova:discount-claimed', { bubbles: true, detail: { email: value, discount: amount, source: 'scratch-popup' } }));
        });
        if (email) {
          email.addEventListener('input', function () {
            if (errorLine) errorLine.hidden = true;
            email.removeAttribute('aria-invalid');
          });
        }
      }

      function focusables() {
        return Array.prototype.slice.call(root.querySelectorAll('button, input, [tabindex="0"]')).filter(function (el) {
          return !el.disabled && !el.hidden && !el.closest('[hidden]') && el.getAttribute('aria-hidden') !== 'true' && el.tabIndex >= 0;
        });
      }
      function onKey(e) {
        if (!st.open) return;
        if (e.key === 'Escape') {
          e.preventDefault();
          close();
          return;
        }
        if (e.key !== 'Tab') return;
        var list = focusables();
        if (!list.length) return;
        var first = list[0];
        var last = list[list.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === root)) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
      var resizeRaf = 0;
      function onResize() {
        if (!st.open || st.touched || st.done) return;
        if (resizeRaf) return;
        resizeRaf = window.requestAnimationFrame(function () {
          resizeRaf = 0;
          prepare();
        });
      }

      function open(opts) {
        if (st.open) return;
        opts = opts || {};
        st.open = true;
        window.clearTimeout(st.timer);
        st.prevFocus = document.activeElement;
        root.hidden = false;
        document.documentElement.classList.add('cova-popup-lock');
        if (!opts.preview) storageSet(SEEN_KEY, '1');
        // make sure the label font is ready before the coating is painted
        var ready = document.fonts && document.fonts.load ? document.fonts.load('800 36px Figtree') : null;
        var go = function () {
          if (st.open && !st.touched && !st.done) prepare();
        };
        prepare();
        if (ready && ready.then) ready.then(go, go);
        window.requestAnimationFrame(function () {
          root.classList.add('is-open');
        });
        try {
          root.focus({ preventScroll: true });
        } catch (e) {
          root.focus();
        }
        document.addEventListener('keydown', onKey);
        window.addEventListener('resize', onResize);
        root.dispatchEvent(new CustomEvent('cova:popup-open', { bubbles: true }));
      }

      function close() {
        if (!st.open) return;
        st.open = false;
        root.classList.remove('is-open');
        document.removeEventListener('keydown', onKey);
        window.removeEventListener('resize', onResize);
        var hide = function () {
          if (st.open) return;
          root.hidden = true;
          document.documentElement.classList.remove('cova-popup-lock');
        };
        if (reduceMotion()) hide();
        else window.setTimeout(hide, 360);
        var back = st.prevFocus;
        if (back && back.focus && document.contains(back)) {
          try {
            back.focus({ preventScroll: true });
          } catch (e) {}
        }
        root.dispatchEvent(new CustomEvent('cova:popup-close', { bubbles: true, detail: { claimed: st.claimed } }));
      }

      closeBtn.addEventListener('click', close);

      function schedule() {
        if (designMode()) return; // in the theme editor the popup opens when the section is selected
        if (blocked() || storageGet(SEEN_KEY)) return;
        st.timer = window.setTimeout(function () {
          if (blocked() || storageGet(SEEN_KEY)) return;
          open();
        }, delay * 1000);
      }
      schedule();

      root.covaPopup = { open: open, close: close };
    }

    function init(scope) {
      var list = (scope || document).querySelectorAll('[data-cova-popup]');
      for (var i = 0; i < list.length; i++) setup(list[i]);
    }

    window.CovaPopup = { init: init };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:section:select', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('[data-cova-popup]') : null;
      if (root && root.covaPopup) root.covaPopup.open({ preview: true });
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('[data-cova-popup]') : null;
      if (root && root.covaPopup) root.covaPopup.close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boxing-band-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.CovaVideoInit) return;
    window.CovaVideoInit = true;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-cova-video-play]') : null;
      if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
      var frame = btn.closest('[data-cova-video]');
      if (!frame) return;
      var video = frame.querySelector('video');
      var embed = frame.getAttribute('data-embed');
      if (video) {
        video.controls = true;
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
        frame.classList.add('is-playing');
      } else if (embed) {
        var stage = frame.querySelector('[data-cova-video-stage]');
        if (!stage) return;
        var frameEl = document.createElement('iframe');
        frameEl.src = embed;
        frameEl.allow = 'autoplay; fullscreen; picture-in-picture';
        frameEl.setAttribute('allowfullscreen', '');
        frameEl.title = btn.getAttribute('aria-label') || 'Video';
        stage.appendChild(frameEl);
        frame.classList.add('is-playing');
      }
    });

    // when a video ends, show the poster and play button again
    document.addEventListener(
      'ended',
      function (e) {
        var frame = e.target.closest ? e.target.closest('[data-cova-video]') : null;
        if (!frame) return;
        e.target.controls = false;
        frame.classList.remove('is-playing');
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["garden-seeds-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    if (window.CovaHeroGallery) return;

    function initGallery(root) {
      if (root.dataset.covaGalleryInit) return;
      var track = root.querySelector('[data-cova-gallery-track]');
      var list = root.querySelector('[data-cova-gallery-list]');
      var wrap = root.querySelector('[data-cova-gallery-thumbs]');
      if (!track || !list || !wrap) return;
      root.dataset.covaGalleryInit = '1';
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-cova-gallery-thumb]'));
      var clamp = root.hasAttribute('data-cova-gallery-clamp');
      var reduce = false;
      try {
        reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) {}
      var active = -1;
      var raf = 0;

      function pitch() {
        if (thumbs.length > 1) return thumbs[1].parentElement.offsetTop - thumbs[0].parentElement.offsetTop;
        return thumbs[0] ? thumbs[0].offsetHeight : 0;
      }
      function update() {
        raf = 0;
        var w = track.clientWidth || 1;
        var count = thumbs.length;
        var p = Math.max(0, Math.min(count - 1, track.scrollLeft / w));
        var shift = p * pitch();
        if (clamp) shift = Math.min(shift, Math.max(0, list.offsetHeight - wrap.clientHeight));
        list.style.transform = 'translate3d(0,' + -shift.toFixed(2) + 'px,0)';
        var i = Math.round(p);
        if (i !== active) {
          active = i;
          thumbs.forEach(function (t, n) {
            var on = n === i;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-current', on ? 'true' : 'false');
          });
        }
      }
      function queue() {
        if (!raf) raf = window.requestAnimationFrame(update);
      }
      function goTo(i) {
        track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      }

      track.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue);
      thumbs.forEach(function (t, n) {
        t.addEventListener('click', function () {
          goTo(n);
        });
      });
      if (window.ResizeObserver) new window.ResizeObserver(queue).observe(root);
      update();
    }

    function init(scope) {
      (scope || document).querySelectorAll('[data-cova-gallery]').forEach(initGallery);
    }
    window.CovaHeroGallery = { init: init };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["garden-seeds-proven-stats"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.CovaStatsCountInit) return;
    window.CovaStatsCountInit = true;

    var DURATION = 1400; // ms, ease-out
    var STAGGER = 140; // ms between the cards
    var reduceMq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    function esc(t) {
      return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    // "93%" -> prefix "", number "93", suffix "%". Anything else (no number, thousands separators) stays as is.
    function parse(text) {
      var m = /^(\D*?)(\d+(?:\.\d+)?)(\D*)$/.exec(text);
      if (!m) return null;
      var dot = m[2].indexOf('.');
      return { pre: m[1], post: m[3], value: parseFloat(m[2]), decimals: dot < 0 ? 0 : m[2].length - dot - 1 };
    }

    // Pin the box to the width of the final text (so nothing around it can move), then show the start value.
    function prepare(el) {
      var finalText = el.textContent.trim();
      var info = parse(finalText);
      if (!info) return null;
      el.style.minWidth = Math.ceil(el.getBoundingClientRect().width * 100) / 100 + 'px';
      el.innerHTML = '<span class="cova-visually-hidden">' + esc(finalText) + '</span><span aria-hidden="true"></span>';
      var job = { el: el, text: el.lastChild, finalText: finalText, info: info };
      show(job, 0);
      return job;
    }

    function show(job, value) {
      job.text.textContent = job.info.pre + value.toFixed(job.info.decimals) + job.info.post;
    }

    function run(jobs) {
      var t0 = null;
      function frame(now) {
        if (t0 === null) t0 = now;
        var running = false;
        for (var i = 0; i < jobs.length; i++) {
          var job = jobs[i];
          if (job.done) continue;
          var p = (now - t0 - i * STAGGER) / DURATION;
          if (p >= 1) {
            job.done = true;
            job.el.textContent = job.finalText; // the text exactly as authored in the setting
            continue;
          }
          running = true;
          p = p < 0 ? 0 : p;
          show(job, job.info.value * (1 - Math.pow(1 - p, 3)));
        }
        if (running) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    function arm(root) {
      var sections = (root || document).querySelectorAll('[data-cova-proven-stats]');
      Array.prototype.forEach.call(sections, function (section) {
        if (section.getAttribute('data-cova-count-state')) return;
        section.setAttribute('data-cova-count-state', 'armed');
        if ((reduceMq && reduceMq.matches) || !('IntersectionObserver' in window)) return;
        var els = section.querySelectorAll('[data-cova-count]');
        if (!els.length) return;
        var fontsReady = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
        var jobs = null;
        var seen = false;
        fontsReady.then(function () {
          // measure once the font is loaded, then park every number at 0 until the section is seen
          jobs = [];
          Array.prototype.forEach.call(els, function (el) {
            var job = prepare(el);
            if (job) jobs.push(job);
          });
          if (seen && jobs.length) run(jobs);
        });
        var io = new IntersectionObserver(
          function (entries) {
            for (var i = 0; i < entries.length; i++) {
              if (!entries[i].isIntersecting) continue;
              io.disconnect();
              seen = true;
              if (jobs && jobs.length) run(jobs);
              break;
            }
          },
          { threshold: 0.3 }
        );
        io.observe(section);
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { arm(); });
    else arm();
    document.addEventListener('shopify:section:load', function (e) { arm(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["garden-seeds-scratch-popup"]) return;
  try {
    
  (function () {
    'use strict';
    if (window.CovaPopup) {
      window.CovaPopup.init(document);
      return;
    }

    var SEEN_KEY = 'cova:popup-seen';
    var BRUSH = 46; // scratch brush width in CSS px
    var THRESHOLD = 0.5; // share of the coating that has to go before the prize is revealed
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    function storageGet(key) {
      try {
        return window.localStorage.getItem(key);
      } catch (e) {
        return null;
      }
    }
    function storageSet(key, value) {
      try {
        window.localStorage.setItem(key, value);
      } catch (e) {}
    }
    function blocked() {
      var html = document.documentElement;
      return html.hasAttribute('data-cova-no-popup') || (document.body && document.body.hasAttribute('data-cova-no-popup'));
    }
    function designMode() {
      return !!(window.Shopify && window.Shopify.designMode);
    }
    function q(root, name) {
      return root.querySelector('[data-cova-popup-' + name + ']');
    }
    function reduceMotion() {
      try {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) {
        return false;
      }
    }

    /* ---------------------------------------------------------------- gold coating */
    function roundRect(ctx, x, y, w, h, r) {
      ctx.beginPath();
      ctx.moveTo(x + r, y);
      ctx.arcTo(x + w, y, x + w, y + h, r);
      ctx.arcTo(x + w, y + h, x, y + h, r);
      ctx.arcTo(x, y + h, x, y, r);
      ctx.arcTo(x, y, x + w, y, r);
      ctx.closePath();
    }

    function paintCoating(ctx, w, h, label) {
      ctx.globalCompositeOperation = 'source-over';
      var g = ctx.createLinearGradient(0, 0, w, h);
      g.addColorStop(0, '#f6d982');
      g.addColorStop(0.28, '#e4bc5d');
      g.addColorStop(0.5, '#f3d47c');
      g.addColorStop(0.74, '#d6aa45');
      g.addColorStop(1, '#ebc869');
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, w, h);

      // soft light sweep, like foil catching light
      var sweep = ctx.createLinearGradient(0, h * 0.15, w, h * 0.05);
      sweep.addColorStop(0, 'rgba(255,255,255,0)');
      sweep.addColorStop(0.5, 'rgba(255,255,255,0.22)');
      sweep.addColorStop(1, 'rgba(255,255,255,0)');
      ctx.fillStyle = sweep;
      ctx.fillRect(0, 0, w, h * 0.6);

      // fine grain
      var specks = Math.round((w * h) / 48);
      for (var i = 0; i < specks; i++) {
        var x = Math.random() * w;
        var y = Math.random() * h;
        var dark = Math.random() < 0.45;
        ctx.fillStyle = dark ? 'rgba(120,86,20,' + (0.04 + Math.random() * 0.1) + ')' : 'rgba(255,248,214,' + (0.08 + Math.random() * 0.2) + ')';
        var s = 0.5 + Math.random() * 1.3;
        ctx.fillRect(x, y, s, s);
      }

      // darker brush strokes behind the label
      ctx.save();
      ctx.globalAlpha = 0.17;
      ctx.fillStyle = '#6d5220';
      for (var k = 0; k < 5; k++) {
        ctx.save();
        ctx.translate(w * (0.2 + 0.15 * k), h * 0.56);
        ctx.rotate(-0.3);
        roundRect(ctx, -w * 0.045, -h * 0.27, w * 0.095, h * 0.54, w * 0.02);
        ctx.fill();
        ctx.restore();
      }
      ctx.restore();

      // label
      var size = Math.min(36, w * 0.105);
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      var family = 'Figtree, system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif';
      ctx.font = '800 ' + size + 'px ' + family;
      while (size > 14 && ctx.measureText(label).width > w * 0.84) {
        size -= 1;
        ctx.font = '800 ' + size + 'px ' + family;
      }
      ctx.save();
      ctx.shadowColor = 'rgba(110,80,20,0.35)';
      ctx.shadowBlur = 3;
      ctx.shadowOffsetY = 1;
      ctx.fillStyle = 'rgba(255,250,232,0.66)';
      ctx.fillText(label, w / 2, h / 2 + 1);
      ctx.restore();
    }

    /* ---------------------------------------------------------------- one popup */
    function setup(root) {
      if (root.covaPopup) return;
      var card = q(root, 'card');
      var canvas = q(root, 'canvas');
      var reveal = q(root, 'reveal');
      var claimBtn = q(root, 'claim');
      var form = q(root, 'form');
      var email = q(root, 'email');
      var errorLine = q(root, 'error-line');
      var success = q(root, 'success');
      var closeBtn = q(root, 'close');
      if (!card || !canvas || !closeBtn) return;

      var delay = parseFloat(root.getAttribute('data-cova-popup-delay'));
      if (isNaN(delay) || delay < 0) delay = 10;
      var amount = root.getAttribute('data-cova-popup-amount') || '';
      var errorText = root.getAttribute('data-cova-popup-error') || '';
      var closeLabel = root.getAttribute('data-cova-popup-close-label') || '';
      var label = canvas.getAttribute('data-cova-popup-label') || '';
      var ctx = canvas.getContext ? canvas.getContext('2d', { willReadFrequently: true }) : null;

      var st = { open: false, done: false, touched: false, drawing: false, last: null, lastCheck: 0, w: 0, h: 0, dpr: 1, timer: 0, prevFocus: null, claimed: false };

      function prepare() {
        if (!ctx) {
          finish();
          return;
        }
        var rect = card.getBoundingClientRect();
        if (!rect.width) return;
        st.dpr = Math.min(window.devicePixelRatio || 1, 2);
        st.w = Math.round(rect.width);
        st.h = Math.round(rect.height);
        canvas.width = Math.round(st.w * st.dpr);
        canvas.height = Math.round(st.h * st.dpr);
        ctx.setTransform(st.dpr, 0, 0, st.dpr, 0, 0);
        ctx.clearRect(0, 0, st.w, st.h);
        paintCoating(ctx, st.w, st.h, label);
        st.touched = false;
      }

      function point(e) {
        var r = canvas.getBoundingClientRect();
        return { x: ((e.clientX - r.left) / r.width) * st.w, y: ((e.clientY - r.top) / r.height) * st.h };
      }
      function stroke(from, to) {
        ctx.globalCompositeOperation = 'destination-out';
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.lineWidth = BRUSH;
        ctx.beginPath();
        ctx.moveTo(from.x, from.y);
        ctx.lineTo(to.x, to.y);
        ctx.stroke();
        ctx.globalCompositeOperation = 'source-over';
      }
      function cleared() {
        var cw = canvas.width;
        var ch = canvas.height;
        var data;
        try {
          data = ctx.getImageData(0, 0, cw, ch).data;
        } catch (e) {
          return 0;
        }
        var step = Math.max(4, Math.round(st.dpr * 4));
        var total = 0;
        var gone = 0;
        for (var y = 0; y < ch; y += step) {
          for (var x = 0; x < cw; x += step) {
            total++;
            if (data[(y * cw + x) * 4 + 3] < 40) gone++;
          }
        }
        return total ? gone / total : 0;
      }
      function check() {
        st.lastCheck = Date.now();
        if (!st.done && cleared() >= THRESHOLD) finish();
      }

      function finish() {
        if (st.done) return;
        st.done = true;
        st.drawing = false;
        canvas.classList.add('is-cleared');
        canvas.setAttribute('aria-hidden', 'true');
        canvas.tabIndex = -1;
        if (reveal) {
          reveal.hidden = false;
          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
              reveal.classList.add('is-shown');
            });
          });
        }
      }

      canvas.addEventListener('pointerdown', function (e) {
        if (st.done || !ctx) return;
        e.preventDefault();
        try {
          canvas.setPointerCapture(e.pointerId);
        } catch (err) {}
        st.drawing = true;
        st.touched = true;
        st.last = point(e);
        stroke(st.last, st.last);
      });
      canvas.addEventListener('pointermove', function (e) {
        if (!st.drawing || st.done) return;
        e.preventDefault();
        var p = point(e);
        stroke(st.last, p);
        st.last = p;
        if (Date.now() - st.lastCheck > 90) check();
      });
      function stop() {
        if (!st.drawing) return;
        st.drawing = false;
        check();
      }
      canvas.addEventListener('pointerup', stop);
      canvas.addEventListener('pointercancel', stop);
      canvas.addEventListener('lostpointercapture', stop);
      canvas.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (ctx) ctx.clearRect(0, 0, st.w, st.h);
          finish();
        }
      });

      if (claimBtn && form) {
        claimBtn.addEventListener('click', function () {
          claimBtn.hidden = true;
          form.hidden = false;
          if (email) email.focus();
        });
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var value = (email ? email.value : '').trim();
          if (!EMAIL_RE.test(value)) {
            if (errorLine) {
              errorLine.textContent = errorText;
              errorLine.hidden = false;
            }
            if (email) {
              email.setAttribute('aria-invalid', 'true');
              email.focus();
            }
            return;
          }
          if (errorLine) errorLine.hidden = true;
          if (email) email.removeAttribute('aria-invalid');
          st.claimed = true;
          form.hidden = true;
          if (success) success.hidden = false;
          if (closeLabel) closeBtn.textContent = closeLabel;
          // The email is sent by a separate integration that listens for this event.
          root.dispatchEvent(new CustomEvent('cova:discount-claimed', { bubbles: true, detail: { email: value, discount: amount, source: 'scratch-popup' } }));
        });
        if (email) {
          email.addEventListener('input', function () {
            if (errorLine) errorLine.hidden = true;
            email.removeAttribute('aria-invalid');
          });
        }
      }

      function focusables() {
        return Array.prototype.slice.call(root.querySelectorAll('button, input, [tabindex="0"]')).filter(function (el) {
          return !el.disabled && !el.hidden && !el.closest('[hidden]') && el.getAttribute('aria-hidden') !== 'true' && el.tabIndex >= 0;
        });
      }
      function onKey(e) {
        if (!st.open) return;
        if (e.key === 'Escape') {
          e.preventDefault();
          close();
          return;
        }
        if (e.key !== 'Tab') return;
        var list = focusables();
        if (!list.length) return;
        var first = list[0];
        var last = list[list.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === root)) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
      var resizeRaf = 0;
      function onResize() {
        if (!st.open || st.touched || st.done) return;
        if (resizeRaf) return;
        resizeRaf = window.requestAnimationFrame(function () {
          resizeRaf = 0;
          prepare();
        });
      }

      function open(opts) {
        if (st.open) return;
        opts = opts || {};
        st.open = true;
        window.clearTimeout(st.timer);
        st.prevFocus = document.activeElement;
        root.hidden = false;
        document.documentElement.classList.add('cova-popup-lock');
        if (!opts.preview) storageSet(SEEN_KEY, '1');
        // make sure the label font is ready before the coating is painted
        var ready = document.fonts && document.fonts.load ? document.fonts.load('800 36px Figtree') : null;
        var go = function () {
          if (st.open && !st.touched && !st.done) prepare();
        };
        prepare();
        if (ready && ready.then) ready.then(go, go);
        window.requestAnimationFrame(function () {
          root.classList.add('is-open');
        });
        try {
          root.focus({ preventScroll: true });
        } catch (e) {
          root.focus();
        }
        document.addEventListener('keydown', onKey);
        window.addEventListener('resize', onResize);
        root.dispatchEvent(new CustomEvent('cova:popup-open', { bubbles: true }));
      }

      function close() {
        if (!st.open) return;
        st.open = false;
        root.classList.remove('is-open');
        document.removeEventListener('keydown', onKey);
        window.removeEventListener('resize', onResize);
        var hide = function () {
          if (st.open) return;
          root.hidden = true;
          document.documentElement.classList.remove('cova-popup-lock');
        };
        if (reduceMotion()) hide();
        else window.setTimeout(hide, 360);
        var back = st.prevFocus;
        if (back && back.focus && document.contains(back)) {
          try {
            back.focus({ preventScroll: true });
          } catch (e) {}
        }
        root.dispatchEvent(new CustomEvent('cova:popup-close', { bubbles: true, detail: { claimed: st.claimed } }));
      }

      closeBtn.addEventListener('click', close);

      function schedule() {
        if (designMode()) return; // in the theme editor the popup opens when the section is selected
        if (blocked() || storageGet(SEEN_KEY)) return;
        st.timer = window.setTimeout(function () {
          if (blocked() || storageGet(SEEN_KEY)) return;
          open();
        }, delay * 1000);
      }
      schedule();

      root.covaPopup = { open: open, close: close };
    }

    function init(scope) {
      var list = (scope || document).querySelectorAll('[data-cova-popup]');
      for (var i = 0; i < list.length; i++) setup(list[i]);
    }

    window.CovaPopup = { init: init };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:section:select', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('[data-cova-popup]') : null;
      if (root && root.covaPopup) root.covaPopup.open({ preview: true });
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('[data-cova-popup]') : null;
      if (root && root.covaPopup) root.covaPopup.close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["garden-seeds-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.CovaVideoInit) return;
    window.CovaVideoInit = true;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-cova-video-play]') : null;
      if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
      var frame = btn.closest('[data-cova-video]');
      if (!frame) return;
      var video = frame.querySelector('video');
      var embed = frame.getAttribute('data-embed');
      if (video) {
        video.controls = true;
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
        frame.classList.add('is-playing');
      } else if (embed) {
        var stage = frame.querySelector('[data-cova-video-stage]');
        if (!stage) return;
        var frameEl = document.createElement('iframe');
        frameEl.src = embed;
        frameEl.allow = 'autoplay; fullscreen; picture-in-picture';
        frameEl.setAttribute('allowfullscreen', '');
        frameEl.title = btn.getAttribute('aria-label') || 'Video';
        stage.appendChild(frameEl);
        frame.classList.add('is-playing');
      }
    });

    // when a video ends, show the poster and play button again
    document.addEventListener(
      'ended',
      function (e) {
        var frame = e.target.closest ? e.target.closest('[data-cova-video]') : null;
        if (!frame) return;
        e.target.controls = false;
        frame.classList.remove('is-playing');
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magnetic-blocks-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    if (window.CovaHeroGallery) return;

    function initGallery(root) {
      if (root.dataset.covaGalleryInit) return;
      var track = root.querySelector('[data-cova-gallery-track]');
      var list = root.querySelector('[data-cova-gallery-list]');
      var wrap = root.querySelector('[data-cova-gallery-thumbs]');
      if (!track || !list || !wrap) return;
      root.dataset.covaGalleryInit = '1';
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-cova-gallery-thumb]'));
      var clamp = root.hasAttribute('data-cova-gallery-clamp');
      var reduce = false;
      try {
        reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) {}
      var active = -1;
      var raf = 0;

      function pitch() {
        if (thumbs.length > 1) return thumbs[1].parentElement.offsetTop - thumbs[0].parentElement.offsetTop;
        return thumbs[0] ? thumbs[0].offsetHeight : 0;
      }
      function update() {
        raf = 0;
        var w = track.clientWidth || 1;
        var count = thumbs.length;
        var p = Math.max(0, Math.min(count - 1, track.scrollLeft / w));
        var shift = p * pitch();
        if (clamp) shift = Math.min(shift, Math.max(0, list.offsetHeight - wrap.clientHeight));
        list.style.transform = 'translate3d(0,' + -shift.toFixed(2) + 'px,0)';
        var i = Math.round(p);
        if (i !== active) {
          active = i;
          thumbs.forEach(function (t, n) {
            var on = n === i;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-current', on ? 'true' : 'false');
          });
        }
      }
      function queue() {
        if (!raf) raf = window.requestAnimationFrame(update);
      }
      function goTo(i) {
        track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      }

      track.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue);
      thumbs.forEach(function (t, n) {
        t.addEventListener('click', function () {
          goTo(n);
        });
      });
      if (window.ResizeObserver) new window.ResizeObserver(queue).observe(root);
      update();
    }

    function init(scope) {
      (scope || document).querySelectorAll('[data-cova-gallery]').forEach(initGallery);
    }
    window.CovaHeroGallery = { init: init };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magnetic-blocks-proven-stats"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.CovaStatsCountInit) return;
    window.CovaStatsCountInit = true;

    var DURATION = 1400; // ms, ease-out
    var STAGGER = 140; // ms between the cards
    var reduceMq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    function esc(t) {
      return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    // "93%" -> prefix "", number "93", suffix "%". Anything else (no number, thousands separators) stays as is.
    function parse(text) {
      var m = /^(\D*?)(\d+(?:\.\d+)?)(\D*)$/.exec(text);
      if (!m) return null;
      var dot = m[2].indexOf('.');
      return { pre: m[1], post: m[3], value: parseFloat(m[2]), decimals: dot < 0 ? 0 : m[2].length - dot - 1 };
    }

    // Pin the box to the width of the final text (so nothing around it can move), then show the start value.
    function prepare(el) {
      var finalText = el.textContent.trim();
      var info = parse(finalText);
      if (!info) return null;
      el.style.minWidth = Math.ceil(el.getBoundingClientRect().width * 100) / 100 + 'px';
      el.innerHTML = '<span class="cova-visually-hidden">' + esc(finalText) + '</span><span aria-hidden="true"></span>';
      var job = { el: el, text: el.lastChild, finalText: finalText, info: info };
      show(job, 0);
      return job;
    }

    function show(job, value) {
      job.text.textContent = job.info.pre + value.toFixed(job.info.decimals) + job.info.post;
    }

    function run(jobs) {
      var t0 = null;
      function frame(now) {
        if (t0 === null) t0 = now;
        var running = false;
        for (var i = 0; i < jobs.length; i++) {
          var job = jobs[i];
          if (job.done) continue;
          var p = (now - t0 - i * STAGGER) / DURATION;
          if (p >= 1) {
            job.done = true;
            job.el.textContent = job.finalText; // the text exactly as authored in the setting
            continue;
          }
          running = true;
          p = p < 0 ? 0 : p;
          show(job, job.info.value * (1 - Math.pow(1 - p, 3)));
        }
        if (running) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    function arm(root) {
      var sections = (root || document).querySelectorAll('[data-cova-proven-stats]');
      Array.prototype.forEach.call(sections, function (section) {
        if (section.getAttribute('data-cova-count-state')) return;
        section.setAttribute('data-cova-count-state', 'armed');
        if ((reduceMq && reduceMq.matches) || !('IntersectionObserver' in window)) return;
        var els = section.querySelectorAll('[data-cova-count]');
        if (!els.length) return;
        var fontsReady = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
        var jobs = null;
        var seen = false;
        fontsReady.then(function () {
          // measure once the font is loaded, then park every number at 0 until the section is seen
          jobs = [];
          Array.prototype.forEach.call(els, function (el) {
            var job = prepare(el);
            if (job) jobs.push(job);
          });
          if (seen && jobs.length) run(jobs);
        });
        var io = new IntersectionObserver(
          function (entries) {
            for (var i = 0; i < entries.length; i++) {
              if (!entries[i].isIntersecting) continue;
              io.disconnect();
              seen = true;
              if (jobs && jobs.length) run(jobs);
              break;
            }
          },
          { threshold: 0.3 }
        );
        io.observe(section);
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { arm(); });
    else arm();
    document.addEventListener('shopify:section:load', function (e) { arm(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magnetic-blocks-scratch-popup"]) return;
  try {
    
  (function () {
    'use strict';
    if (window.CovaPopup) {
      window.CovaPopup.init(document);
      return;
    }

    var SEEN_KEY = 'cova:popup-seen';
    var BRUSH = 46; // scratch brush width in CSS px
    var THRESHOLD = 0.5; // share of the coating that has to go before the prize is revealed
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    function storageGet(key) {
      try {
        return window.localStorage.getItem(key);
      } catch (e) {
        return null;
      }
    }
    function storageSet(key, value) {
      try {
        window.localStorage.setItem(key, value);
      } catch (e) {}
    }
    function blocked() {
      var html = document.documentElement;
      return html.hasAttribute('data-cova-no-popup') || (document.body && document.body.hasAttribute('data-cova-no-popup'));
    }
    function designMode() {
      return !!(window.Shopify && window.Shopify.designMode);
    }
    function q(root, name) {
      return root.querySelector('[data-cova-popup-' + name + ']');
    }
    function reduceMotion() {
      try {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) {
        return false;
      }
    }

    /* ---------------------------------------------------------------- gold coating */
    function roundRect(ctx, x, y, w, h, r) {
      ctx.beginPath();
      ctx.moveTo(x + r, y);
      ctx.arcTo(x + w, y, x + w, y + h, r);
      ctx.arcTo(x + w, y + h, x, y + h, r);
      ctx.arcTo(x, y + h, x, y, r);
      ctx.arcTo(x, y, x + w, y, r);
      ctx.closePath();
    }

    function paintCoating(ctx, w, h, label) {
      ctx.globalCompositeOperation = 'source-over';
      var g = ctx.createLinearGradient(0, 0, w, h);
      g.addColorStop(0, '#f6d982');
      g.addColorStop(0.28, '#e4bc5d');
      g.addColorStop(0.5, '#f3d47c');
      g.addColorStop(0.74, '#d6aa45');
      g.addColorStop(1, '#ebc869');
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, w, h);

      // soft light sweep, like foil catching light
      var sweep = ctx.createLinearGradient(0, h * 0.15, w, h * 0.05);
      sweep.addColorStop(0, 'rgba(255,255,255,0)');
      sweep.addColorStop(0.5, 'rgba(255,255,255,0.22)');
      sweep.addColorStop(1, 'rgba(255,255,255,0)');
      ctx.fillStyle = sweep;
      ctx.fillRect(0, 0, w, h * 0.6);

      // fine grain
      var specks = Math.round((w * h) / 48);
      for (var i = 0; i < specks; i++) {
        var x = Math.random() * w;
        var y = Math.random() * h;
        var dark = Math.random() < 0.45;
        ctx.fillStyle = dark ? 'rgba(120,86,20,' + (0.04 + Math.random() * 0.1) + ')' : 'rgba(255,248,214,' + (0.08 + Math.random() * 0.2) + ')';
        var s = 0.5 + Math.random() * 1.3;
        ctx.fillRect(x, y, s, s);
      }

      // darker brush strokes behind the label
      ctx.save();
      ctx.globalAlpha = 0.17;
      ctx.fillStyle = '#6d5220';
      for (var k = 0; k < 5; k++) {
        ctx.save();
        ctx.translate(w * (0.2 + 0.15 * k), h * 0.56);
        ctx.rotate(-0.3);
        roundRect(ctx, -w * 0.045, -h * 0.27, w * 0.095, h * 0.54, w * 0.02);
        ctx.fill();
        ctx.restore();
      }
      ctx.restore();

      // label
      var size = Math.min(36, w * 0.105);
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      var family = 'Figtree, system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif';
      ctx.font = '800 ' + size + 'px ' + family;
      while (size > 14 && ctx.measureText(label).width > w * 0.84) {
        size -= 1;
        ctx.font = '800 ' + size + 'px ' + family;
      }
      ctx.save();
      ctx.shadowColor = 'rgba(110,80,20,0.35)';
      ctx.shadowBlur = 3;
      ctx.shadowOffsetY = 1;
      ctx.fillStyle = 'rgba(255,250,232,0.66)';
      ctx.fillText(label, w / 2, h / 2 + 1);
      ctx.restore();
    }

    /* ---------------------------------------------------------------- one popup */
    function setup(root) {
      if (root.covaPopup) return;
      var card = q(root, 'card');
      var canvas = q(root, 'canvas');
      var reveal = q(root, 'reveal');
      var claimBtn = q(root, 'claim');
      var form = q(root, 'form');
      var email = q(root, 'email');
      var errorLine = q(root, 'error-line');
      var success = q(root, 'success');
      var closeBtn = q(root, 'close');
      if (!card || !canvas || !closeBtn) return;

      var delay = parseFloat(root.getAttribute('data-cova-popup-delay'));
      if (isNaN(delay) || delay < 0) delay = 10;
      var amount = root.getAttribute('data-cova-popup-amount') || '';
      var errorText = root.getAttribute('data-cova-popup-error') || '';
      var closeLabel = root.getAttribute('data-cova-popup-close-label') || '';
      var label = canvas.getAttribute('data-cova-popup-label') || '';
      var ctx = canvas.getContext ? canvas.getContext('2d', { willReadFrequently: true }) : null;

      var st = { open: false, done: false, touched: false, drawing: false, last: null, lastCheck: 0, w: 0, h: 0, dpr: 1, timer: 0, prevFocus: null, claimed: false };

      function prepare() {
        if (!ctx) {
          finish();
          return;
        }
        var rect = card.getBoundingClientRect();
        if (!rect.width) return;
        st.dpr = Math.min(window.devicePixelRatio || 1, 2);
        st.w = Math.round(rect.width);
        st.h = Math.round(rect.height);
        canvas.width = Math.round(st.w * st.dpr);
        canvas.height = Math.round(st.h * st.dpr);
        ctx.setTransform(st.dpr, 0, 0, st.dpr, 0, 0);
        ctx.clearRect(0, 0, st.w, st.h);
        paintCoating(ctx, st.w, st.h, label);
        st.touched = false;
      }

      function point(e) {
        var r = canvas.getBoundingClientRect();
        return { x: ((e.clientX - r.left) / r.width) * st.w, y: ((e.clientY - r.top) / r.height) * st.h };
      }
      function stroke(from, to) {
        ctx.globalCompositeOperation = 'destination-out';
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.lineWidth = BRUSH;
        ctx.beginPath();
        ctx.moveTo(from.x, from.y);
        ctx.lineTo(to.x, to.y);
        ctx.stroke();
        ctx.globalCompositeOperation = 'source-over';
      }
      function cleared() {
        var cw = canvas.width;
        var ch = canvas.height;
        var data;
        try {
          data = ctx.getImageData(0, 0, cw, ch).data;
        } catch (e) {
          return 0;
        }
        var step = Math.max(4, Math.round(st.dpr * 4));
        var total = 0;
        var gone = 0;
        for (var y = 0; y < ch; y += step) {
          for (var x = 0; x < cw; x += step) {
            total++;
            if (data[(y * cw + x) * 4 + 3] < 40) gone++;
          }
        }
        return total ? gone / total : 0;
      }
      function check() {
        st.lastCheck = Date.now();
        if (!st.done && cleared() >= THRESHOLD) finish();
      }

      function finish() {
        if (st.done) return;
        st.done = true;
        st.drawing = false;
        canvas.classList.add('is-cleared');
        canvas.setAttribute('aria-hidden', 'true');
        canvas.tabIndex = -1;
        if (reveal) {
          reveal.hidden = false;
          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
              reveal.classList.add('is-shown');
            });
          });
        }
      }

      canvas.addEventListener('pointerdown', function (e) {
        if (st.done || !ctx) return;
        e.preventDefault();
        try {
          canvas.setPointerCapture(e.pointerId);
        } catch (err) {}
        st.drawing = true;
        st.touched = true;
        st.last = point(e);
        stroke(st.last, st.last);
      });
      canvas.addEventListener('pointermove', function (e) {
        if (!st.drawing || st.done) return;
        e.preventDefault();
        var p = point(e);
        stroke(st.last, p);
        st.last = p;
        if (Date.now() - st.lastCheck > 90) check();
      });
      function stop() {
        if (!st.drawing) return;
        st.drawing = false;
        check();
      }
      canvas.addEventListener('pointerup', stop);
      canvas.addEventListener('pointercancel', stop);
      canvas.addEventListener('lostpointercapture', stop);
      canvas.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (ctx) ctx.clearRect(0, 0, st.w, st.h);
          finish();
        }
      });

      if (claimBtn && form) {
        claimBtn.addEventListener('click', function () {
          claimBtn.hidden = true;
          form.hidden = false;
          if (email) email.focus();
        });
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var value = (email ? email.value : '').trim();
          if (!EMAIL_RE.test(value)) {
            if (errorLine) {
              errorLine.textContent = errorText;
              errorLine.hidden = false;
            }
            if (email) {
              email.setAttribute('aria-invalid', 'true');
              email.focus();
            }
            return;
          }
          if (errorLine) errorLine.hidden = true;
          if (email) email.removeAttribute('aria-invalid');
          st.claimed = true;
          form.hidden = true;
          if (success) success.hidden = false;
          if (closeLabel) closeBtn.textContent = closeLabel;
          // The email is sent by a separate integration that listens for this event.
          root.dispatchEvent(new CustomEvent('cova:discount-claimed', { bubbles: true, detail: { email: value, discount: amount, source: 'scratch-popup' } }));
        });
        if (email) {
          email.addEventListener('input', function () {
            if (errorLine) errorLine.hidden = true;
            email.removeAttribute('aria-invalid');
          });
        }
      }

      function focusables() {
        return Array.prototype.slice.call(root.querySelectorAll('button, input, [tabindex="0"]')).filter(function (el) {
          return !el.disabled && !el.hidden && !el.closest('[hidden]') && el.getAttribute('aria-hidden') !== 'true' && el.tabIndex >= 0;
        });
      }
      function onKey(e) {
        if (!st.open) return;
        if (e.key === 'Escape') {
          e.preventDefault();
          close();
          return;
        }
        if (e.key !== 'Tab') return;
        var list = focusables();
        if (!list.length) return;
        var first = list[0];
        var last = list[list.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === root)) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
      var resizeRaf = 0;
      function onResize() {
        if (!st.open || st.touched || st.done) return;
        if (resizeRaf) return;
        resizeRaf = window.requestAnimationFrame(function () {
          resizeRaf = 0;
          prepare();
        });
      }

      function open(opts) {
        if (st.open) return;
        opts = opts || {};
        st.open = true;
        window.clearTimeout(st.timer);
        st.prevFocus = document.activeElement;
        root.hidden = false;
        document.documentElement.classList.add('cova-popup-lock');
        if (!opts.preview) storageSet(SEEN_KEY, '1');
        // make sure the label font is ready before the coating is painted
        var ready = document.fonts && document.fonts.load ? document.fonts.load('800 36px Figtree') : null;
        var go = function () {
          if (st.open && !st.touched && !st.done) prepare();
        };
        prepare();
        if (ready && ready.then) ready.then(go, go);
        window.requestAnimationFrame(function () {
          root.classList.add('is-open');
        });
        try {
          root.focus({ preventScroll: true });
        } catch (e) {
          root.focus();
        }
        document.addEventListener('keydown', onKey);
        window.addEventListener('resize', onResize);
        root.dispatchEvent(new CustomEvent('cova:popup-open', { bubbles: true }));
      }

      function close() {
        if (!st.open) return;
        st.open = false;
        root.classList.remove('is-open');
        document.removeEventListener('keydown', onKey);
        window.removeEventListener('resize', onResize);
        var hide = function () {
          if (st.open) return;
          root.hidden = true;
          document.documentElement.classList.remove('cova-popup-lock');
        };
        if (reduceMotion()) hide();
        else window.setTimeout(hide, 360);
        var back = st.prevFocus;
        if (back && back.focus && document.contains(back)) {
          try {
            back.focus({ preventScroll: true });
          } catch (e) {}
        }
        root.dispatchEvent(new CustomEvent('cova:popup-close', { bubbles: true, detail: { claimed: st.claimed } }));
      }

      closeBtn.addEventListener('click', close);

      function schedule() {
        if (designMode()) return; // in the theme editor the popup opens when the section is selected
        if (blocked() || storageGet(SEEN_KEY)) return;
        st.timer = window.setTimeout(function () {
          if (blocked() || storageGet(SEEN_KEY)) return;
          open();
        }, delay * 1000);
      }
      schedule();

      root.covaPopup = { open: open, close: close };
    }

    function init(scope) {
      var list = (scope || document).querySelectorAll('[data-cova-popup]');
      for (var i = 0; i < list.length; i++) setup(list[i]);
    }

    window.CovaPopup = { init: init };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:section:select', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('[data-cova-popup]') : null;
      if (root && root.covaPopup) root.covaPopup.open({ preview: true });
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('[data-cova-popup]') : null;
      if (root && root.covaPopup) root.covaPopup.close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magnetic-blocks-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.CovaVideoInit) return;
    window.CovaVideoInit = true;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-cova-video-play]') : null;
      if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
      var frame = btn.closest('[data-cova-video]');
      if (!frame) return;
      var video = frame.querySelector('video');
      var embed = frame.getAttribute('data-embed');
      if (video) {
        video.controls = true;
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
        frame.classList.add('is-playing');
      } else if (embed) {
        var stage = frame.querySelector('[data-cova-video-stage]');
        if (!stage) return;
        var frameEl = document.createElement('iframe');
        frameEl.src = embed;
        frameEl.allow = 'autoplay; fullscreen; picture-in-picture';
        frameEl.setAttribute('allowfullscreen', '');
        frameEl.title = btn.getAttribute('aria-label') || 'Video';
        stage.appendChild(frameEl);
        frame.classList.add('is-playing');
      }
    });

    // when a video ends, show the poster and play button again
    document.addEventListener(
      'ended',
      function (e) {
        var frame = e.target.closest ? e.target.closest('[data-cova-video]') : null;
        if (!frame) return;
        e.target.controls = false;
        frame.classList.remove('is-playing');
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pedal-band-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    if (window.CovaHeroGallery) return;

    function initGallery(root) {
      if (root.dataset.covaGalleryInit) return;
      var track = root.querySelector('[data-cova-gallery-track]');
      var list = root.querySelector('[data-cova-gallery-list]');
      var wrap = root.querySelector('[data-cova-gallery-thumbs]');
      if (!track || !list || !wrap) return;
      root.dataset.covaGalleryInit = '1';
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-cova-gallery-thumb]'));
      var clamp = root.hasAttribute('data-cova-gallery-clamp');
      var reduce = false;
      try {
        reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) {}
      var active = -1;
      var raf = 0;

      function pitch() {
        if (thumbs.length > 1) return thumbs[1].parentElement.offsetTop - thumbs[0].parentElement.offsetTop;
        return thumbs[0] ? thumbs[0].offsetHeight : 0;
      }
      function update() {
        raf = 0;
        var w = track.clientWidth || 1;
        var count = thumbs.length;
        var p = Math.max(0, Math.min(count - 1, track.scrollLeft / w));
        var shift = p * pitch();
        if (clamp) shift = Math.min(shift, Math.max(0, list.offsetHeight - wrap.clientHeight));
        list.style.transform = 'translate3d(0,' + -shift.toFixed(2) + 'px,0)';
        var i = Math.round(p);
        if (i !== active) {
          active = i;
          thumbs.forEach(function (t, n) {
            var on = n === i;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-current', on ? 'true' : 'false');
          });
        }
      }
      function queue() {
        if (!raf) raf = window.requestAnimationFrame(update);
      }
      function goTo(i) {
        track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      }

      track.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue);
      thumbs.forEach(function (t, n) {
        t.addEventListener('click', function () {
          goTo(n);
        });
      });
      if (window.ResizeObserver) new window.ResizeObserver(queue).observe(root);
      update();
    }

    function init(scope) {
      (scope || document).querySelectorAll('[data-cova-gallery]').forEach(initGallery);
    }
    window.CovaHeroGallery = { init: init };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pedal-band-proven-stats"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.CovaStatsCountInit) return;
    window.CovaStatsCountInit = true;

    var DURATION = 1400; // ms, ease-out
    var STAGGER = 140; // ms between the cards
    var reduceMq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    function esc(t) {
      return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    // "93%" -> prefix "", number "93", suffix "%". Anything else (no number, thousands separators) stays as is.
    function parse(text) {
      var m = /^(\D*?)(\d+(?:\.\d+)?)(\D*)$/.exec(text);
      if (!m) return null;
      var dot = m[2].indexOf('.');
      return { pre: m[1], post: m[3], value: parseFloat(m[2]), decimals: dot < 0 ? 0 : m[2].length - dot - 1 };
    }

    // Pin the box to the width of the final text (so nothing around it can move), then show the start value.
    function prepare(el) {
      var finalText = el.textContent.trim();
      var info = parse(finalText);
      if (!info) return null;
      el.style.minWidth = Math.ceil(el.getBoundingClientRect().width * 100) / 100 + 'px';
      el.innerHTML = '<span class="cova-visually-hidden">' + esc(finalText) + '</span><span aria-hidden="true"></span>';
      var job = { el: el, text: el.lastChild, finalText: finalText, info: info };
      show(job, 0);
      return job;
    }

    function show(job, value) {
      job.text.textContent = job.info.pre + value.toFixed(job.info.decimals) + job.info.post;
    }

    function run(jobs) {
      var t0 = null;
      function frame(now) {
        if (t0 === null) t0 = now;
        var running = false;
        for (var i = 0; i < jobs.length; i++) {
          var job = jobs[i];
          if (job.done) continue;
          var p = (now - t0 - i * STAGGER) / DURATION;
          if (p >= 1) {
            job.done = true;
            job.el.textContent = job.finalText; // the text exactly as authored in the setting
            continue;
          }
          running = true;
          p = p < 0 ? 0 : p;
          show(job, job.info.value * (1 - Math.pow(1 - p, 3)));
        }
        if (running) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    function arm(root) {
      var sections = (root || document).querySelectorAll('[data-cova-proven-stats]');
      Array.prototype.forEach.call(sections, function (section) {
        if (section.getAttribute('data-cova-count-state')) return;
        section.setAttribute('data-cova-count-state', 'armed');
        if ((reduceMq && reduceMq.matches) || !('IntersectionObserver' in window)) return;
        var els = section.querySelectorAll('[data-cova-count]');
        if (!els.length) return;
        var fontsReady = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
        var jobs = null;
        var seen = false;
        fontsReady.then(function () {
          // measure once the font is loaded, then park every number at 0 until the section is seen
          jobs = [];
          Array.prototype.forEach.call(els, function (el) {
            var job = prepare(el);
            if (job) jobs.push(job);
          });
          if (seen && jobs.length) run(jobs);
        });
        var io = new IntersectionObserver(
          function (entries) {
            for (var i = 0; i < entries.length; i++) {
              if (!entries[i].isIntersecting) continue;
              io.disconnect();
              seen = true;
              if (jobs && jobs.length) run(jobs);
              break;
            }
          },
          { threshold: 0.3 }
        );
        io.observe(section);
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { arm(); });
    else arm();
    document.addEventListener('shopify:section:load', function (e) { arm(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pedal-band-scratch-popup"]) return;
  try {
    
  (function () {
    'use strict';
    if (window.CovaPopup) {
      window.CovaPopup.init(document);
      return;
    }

    var SEEN_KEY = 'cova:popup-seen';
    var BRUSH = 46; // scratch brush width in CSS px
    var THRESHOLD = 0.5; // share of the coating that has to go before the prize is revealed
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    function storageGet(key) {
      try {
        return window.localStorage.getItem(key);
      } catch (e) {
        return null;
      }
    }
    function storageSet(key, value) {
      try {
        window.localStorage.setItem(key, value);
      } catch (e) {}
    }
    function blocked() {
      var html = document.documentElement;
      return html.hasAttribute('data-cova-no-popup') || (document.body && document.body.hasAttribute('data-cova-no-popup'));
    }
    function designMode() {
      return !!(window.Shopify && window.Shopify.designMode);
    }
    function q(root, name) {
      return root.querySelector('[data-cova-popup-' + name + ']');
    }
    function reduceMotion() {
      try {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) {
        return false;
      }
    }

    /* ---------------------------------------------------------------- gold coating */
    function roundRect(ctx, x, y, w, h, r) {
      ctx.beginPath();
      ctx.moveTo(x + r, y);
      ctx.arcTo(x + w, y, x + w, y + h, r);
      ctx.arcTo(x + w, y + h, x, y + h, r);
      ctx.arcTo(x, y + h, x, y, r);
      ctx.arcTo(x, y, x + w, y, r);
      ctx.closePath();
    }

    function paintCoating(ctx, w, h, label) {
      ctx.globalCompositeOperation = 'source-over';
      var g = ctx.createLinearGradient(0, 0, w, h);
      g.addColorStop(0, '#f6d982');
      g.addColorStop(0.28, '#e4bc5d');
      g.addColorStop(0.5, '#f3d47c');
      g.addColorStop(0.74, '#d6aa45');
      g.addColorStop(1, '#ebc869');
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, w, h);

      // soft light sweep, like foil catching light
      var sweep = ctx.createLinearGradient(0, h * 0.15, w, h * 0.05);
      sweep.addColorStop(0, 'rgba(255,255,255,0)');
      sweep.addColorStop(0.5, 'rgba(255,255,255,0.22)');
      sweep.addColorStop(1, 'rgba(255,255,255,0)');
      ctx.fillStyle = sweep;
      ctx.fillRect(0, 0, w, h * 0.6);

      // fine grain
      var specks = Math.round((w * h) / 48);
      for (var i = 0; i < specks; i++) {
        var x = Math.random() * w;
        var y = Math.random() * h;
        var dark = Math.random() < 0.45;
        ctx.fillStyle = dark ? 'rgba(120,86,20,' + (0.04 + Math.random() * 0.1) + ')' : 'rgba(255,248,214,' + (0.08 + Math.random() * 0.2) + ')';
        var s = 0.5 + Math.random() * 1.3;
        ctx.fillRect(x, y, s, s);
      }

      // darker brush strokes behind the label
      ctx.save();
      ctx.globalAlpha = 0.17;
      ctx.fillStyle = '#6d5220';
      for (var k = 0; k < 5; k++) {
        ctx.save();
        ctx.translate(w * (0.2 + 0.15 * k), h * 0.56);
        ctx.rotate(-0.3);
        roundRect(ctx, -w * 0.045, -h * 0.27, w * 0.095, h * 0.54, w * 0.02);
        ctx.fill();
        ctx.restore();
      }
      ctx.restore();

      // label
      var size = Math.min(36, w * 0.105);
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      var family = 'Figtree, system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif';
      ctx.font = '800 ' + size + 'px ' + family;
      while (size > 14 && ctx.measureText(label).width > w * 0.84) {
        size -= 1;
        ctx.font = '800 ' + size + 'px ' + family;
      }
      ctx.save();
      ctx.shadowColor = 'rgba(110,80,20,0.35)';
      ctx.shadowBlur = 3;
      ctx.shadowOffsetY = 1;
      ctx.fillStyle = 'rgba(255,250,232,0.66)';
      ctx.fillText(label, w / 2, h / 2 + 1);
      ctx.restore();
    }

    /* ---------------------------------------------------------------- one popup */
    function setup(root) {
      if (root.covaPopup) return;
      var card = q(root, 'card');
      var canvas = q(root, 'canvas');
      var reveal = q(root, 'reveal');
      var claimBtn = q(root, 'claim');
      var form = q(root, 'form');
      var email = q(root, 'email');
      var errorLine = q(root, 'error-line');
      var success = q(root, 'success');
      var closeBtn = q(root, 'close');
      if (!card || !canvas || !closeBtn) return;

      var delay = parseFloat(root.getAttribute('data-cova-popup-delay'));
      if (isNaN(delay) || delay < 0) delay = 10;
      var amount = root.getAttribute('data-cova-popup-amount') || '';
      var errorText = root.getAttribute('data-cova-popup-error') || '';
      var closeLabel = root.getAttribute('data-cova-popup-close-label') || '';
      var label = canvas.getAttribute('data-cova-popup-label') || '';
      var ctx = canvas.getContext ? canvas.getContext('2d', { willReadFrequently: true }) : null;

      var st = { open: false, done: false, touched: false, drawing: false, last: null, lastCheck: 0, w: 0, h: 0, dpr: 1, timer: 0, prevFocus: null, claimed: false };

      function prepare() {
        if (!ctx) {
          finish();
          return;
        }
        var rect = card.getBoundingClientRect();
        if (!rect.width) return;
        st.dpr = Math.min(window.devicePixelRatio || 1, 2);
        st.w = Math.round(rect.width);
        st.h = Math.round(rect.height);
        canvas.width = Math.round(st.w * st.dpr);
        canvas.height = Math.round(st.h * st.dpr);
        ctx.setTransform(st.dpr, 0, 0, st.dpr, 0, 0);
        ctx.clearRect(0, 0, st.w, st.h);
        paintCoating(ctx, st.w, st.h, label);
        st.touched = false;
      }

      function point(e) {
        var r = canvas.getBoundingClientRect();
        return { x: ((e.clientX - r.left) / r.width) * st.w, y: ((e.clientY - r.top) / r.height) * st.h };
      }
      function stroke(from, to) {
        ctx.globalCompositeOperation = 'destination-out';
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.lineWidth = BRUSH;
        ctx.beginPath();
        ctx.moveTo(from.x, from.y);
        ctx.lineTo(to.x, to.y);
        ctx.stroke();
        ctx.globalCompositeOperation = 'source-over';
      }
      function cleared() {
        var cw = canvas.width;
        var ch = canvas.height;
        var data;
        try {
          data = ctx.getImageData(0, 0, cw, ch).data;
        } catch (e) {
          return 0;
        }
        var step = Math.max(4, Math.round(st.dpr * 4));
        var total = 0;
        var gone = 0;
        for (var y = 0; y < ch; y += step) {
          for (var x = 0; x < cw; x += step) {
            total++;
            if (data[(y * cw + x) * 4 + 3] < 40) gone++;
          }
        }
        return total ? gone / total : 0;
      }
      function check() {
        st.lastCheck = Date.now();
        if (!st.done && cleared() >= THRESHOLD) finish();
      }

      function finish() {
        if (st.done) return;
        st.done = true;
        st.drawing = false;
        canvas.classList.add('is-cleared');
        canvas.setAttribute('aria-hidden', 'true');
        canvas.tabIndex = -1;
        if (reveal) {
          reveal.hidden = false;
          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
              reveal.classList.add('is-shown');
            });
          });
        }
      }

      canvas.addEventListener('pointerdown', function (e) {
        if (st.done || !ctx) return;
        e.preventDefault();
        try {
          canvas.setPointerCapture(e.pointerId);
        } catch (err) {}
        st.drawing = true;
        st.touched = true;
        st.last = point(e);
        stroke(st.last, st.last);
      });
      canvas.addEventListener('pointermove', function (e) {
        if (!st.drawing || st.done) return;
        e.preventDefault();
        var p = point(e);
        stroke(st.last, p);
        st.last = p;
        if (Date.now() - st.lastCheck > 90) check();
      });
      function stop() {
        if (!st.drawing) return;
        st.drawing = false;
        check();
      }
      canvas.addEventListener('pointerup', stop);
      canvas.addEventListener('pointercancel', stop);
      canvas.addEventListener('lostpointercapture', stop);
      canvas.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (ctx) ctx.clearRect(0, 0, st.w, st.h);
          finish();
        }
      });

      if (claimBtn && form) {
        claimBtn.addEventListener('click', function () {
          claimBtn.hidden = true;
          form.hidden = false;
          if (email) email.focus();
        });
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var value = (email ? email.value : '').trim();
          if (!EMAIL_RE.test(value)) {
            if (errorLine) {
              errorLine.textContent = errorText;
              errorLine.hidden = false;
            }
            if (email) {
              email.setAttribute('aria-invalid', 'true');
              email.focus();
            }
            return;
          }
          if (errorLine) errorLine.hidden = true;
          if (email) email.removeAttribute('aria-invalid');
          st.claimed = true;
          form.hidden = true;
          if (success) success.hidden = false;
          if (closeLabel) closeBtn.textContent = closeLabel;
          // The email is sent by a separate integration that listens for this event.
          root.dispatchEvent(new CustomEvent('cova:discount-claimed', { bubbles: true, detail: { email: value, discount: amount, source: 'scratch-popup' } }));
        });
        if (email) {
          email.addEventListener('input', function () {
            if (errorLine) errorLine.hidden = true;
            email.removeAttribute('aria-invalid');
          });
        }
      }

      function focusables() {
        return Array.prototype.slice.call(root.querySelectorAll('button, input, [tabindex="0"]')).filter(function (el) {
          return !el.disabled && !el.hidden && !el.closest('[hidden]') && el.getAttribute('aria-hidden') !== 'true' && el.tabIndex >= 0;
        });
      }
      function onKey(e) {
        if (!st.open) return;
        if (e.key === 'Escape') {
          e.preventDefault();
          close();
          return;
        }
        if (e.key !== 'Tab') return;
        var list = focusables();
        if (!list.length) return;
        var first = list[0];
        var last = list[list.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === root)) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
      var resizeRaf = 0;
      function onResize() {
        if (!st.open || st.touched || st.done) return;
        if (resizeRaf) return;
        resizeRaf = window.requestAnimationFrame(function () {
          resizeRaf = 0;
          prepare();
        });
      }

      function open(opts) {
        if (st.open) return;
        opts = opts || {};
        st.open = true;
        window.clearTimeout(st.timer);
        st.prevFocus = document.activeElement;
        root.hidden = false;
        document.documentElement.classList.add('cova-popup-lock');
        if (!opts.preview) storageSet(SEEN_KEY, '1');
        // make sure the label font is ready before the coating is painted
        var ready = document.fonts && document.fonts.load ? document.fonts.load('800 36px Figtree') : null;
        var go = function () {
          if (st.open && !st.touched && !st.done) prepare();
        };
        prepare();
        if (ready && ready.then) ready.then(go, go);
        window.requestAnimationFrame(function () {
          root.classList.add('is-open');
        });
        try {
          root.focus({ preventScroll: true });
        } catch (e) {
          root.focus();
        }
        document.addEventListener('keydown', onKey);
        window.addEventListener('resize', onResize);
        root.dispatchEvent(new CustomEvent('cova:popup-open', { bubbles: true }));
      }

      function close() {
        if (!st.open) return;
        st.open = false;
        root.classList.remove('is-open');
        document.removeEventListener('keydown', onKey);
        window.removeEventListener('resize', onResize);
        var hide = function () {
          if (st.open) return;
          root.hidden = true;
          document.documentElement.classList.remove('cova-popup-lock');
        };
        if (reduceMotion()) hide();
        else window.setTimeout(hide, 360);
        var back = st.prevFocus;
        if (back && back.focus && document.contains(back)) {
          try {
            back.focus({ preventScroll: true });
          } catch (e) {}
        }
        root.dispatchEvent(new CustomEvent('cova:popup-close', { bubbles: true, detail: { claimed: st.claimed } }));
      }

      closeBtn.addEventListener('click', close);

      function schedule() {
        if (designMode()) return; // in the theme editor the popup opens when the section is selected
        if (blocked() || storageGet(SEEN_KEY)) return;
        st.timer = window.setTimeout(function () {
          if (blocked() || storageGet(SEEN_KEY)) return;
          open();
        }, delay * 1000);
      }
      schedule();

      root.covaPopup = { open: open, close: close };
    }

    function init(scope) {
      var list = (scope || document).querySelectorAll('[data-cova-popup]');
      for (var i = 0; i < list.length; i++) setup(list[i]);
    }

    window.CovaPopup = { init: init };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:section:select', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('[data-cova-popup]') : null;
      if (root && root.covaPopup) root.covaPopup.open({ preview: true });
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('[data-cova-popup]') : null;
      if (root && root.covaPopup) root.covaPopup.close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pedal-band-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.CovaVideoInit) return;
    window.CovaVideoInit = true;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-cova-video-play]') : null;
      if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
      var frame = btn.closest('[data-cova-video]');
      if (!frame) return;
      var video = frame.querySelector('video');
      var embed = frame.getAttribute('data-embed');
      if (video) {
        video.controls = true;
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
        frame.classList.add('is-playing');
      } else if (embed) {
        var stage = frame.querySelector('[data-cova-video-stage]');
        if (!stage) return;
        var frameEl = document.createElement('iframe');
        frameEl.src = embed;
        frameEl.allow = 'autoplay; fullscreen; picture-in-picture';
        frameEl.setAttribute('allowfullscreen', '');
        frameEl.title = btn.getAttribute('aria-label') || 'Video';
        stage.appendChild(frameEl);
        frame.classList.add('is-playing');
      }
    });

    // when a video ends, show the poster and play button again
    document.addEventListener(
      'ended',
      function (e) {
        var frame = e.target.closest ? e.target.closest('[data-cova-video]') : null;
        if (!frame) return;
        e.target.controls = false;
        frame.classList.remove('is-playing');
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resetter-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    if (window.CovaHeroGallery) return;

    function initGallery(root) {
      if (root.dataset.covaGalleryInit) return;
      var track = root.querySelector('[data-cova-gallery-track]');
      var list = root.querySelector('[data-cova-gallery-list]');
      var wrap = root.querySelector('[data-cova-gallery-thumbs]');
      if (!track || !list || !wrap) return;
      root.dataset.covaGalleryInit = '1';
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-cova-gallery-thumb]'));
      var clamp = root.hasAttribute('data-cova-gallery-clamp');
      var reduce = false;
      try {
        reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) {}
      var active = -1;
      var raf = 0;

      function pitch() {
        if (thumbs.length > 1) return thumbs[1].parentElement.offsetTop - thumbs[0].parentElement.offsetTop;
        return thumbs[0] ? thumbs[0].offsetHeight : 0;
      }
      function update() {
        raf = 0;
        var w = track.clientWidth || 1;
        var count = thumbs.length;
        var p = Math.max(0, Math.min(count - 1, track.scrollLeft / w));
        var shift = p * pitch();
        if (clamp) shift = Math.min(shift, Math.max(0, list.offsetHeight - wrap.clientHeight));
        list.style.transform = 'translate3d(0,' + -shift.toFixed(2) + 'px,0)';
        var i = Math.round(p);
        if (i !== active) {
          active = i;
          thumbs.forEach(function (t, n) {
            var on = n === i;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-current', on ? 'true' : 'false');
          });
        }
      }
      function queue() {
        if (!raf) raf = window.requestAnimationFrame(update);
      }
      function goTo(i) {
        track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      }

      track.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue);
      thumbs.forEach(function (t, n) {
        t.addEventListener('click', function () {
          goTo(n);
        });
      });
      if (window.ResizeObserver) new window.ResizeObserver(queue).observe(root);
      update();
    }

    function init(scope) {
      (scope || document).querySelectorAll('[data-cova-gallery]').forEach(initGallery);
    }
    window.CovaHeroGallery = { init: init };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resetter-problem-checklist"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.CovaLiverFxInit) return;
    window.CovaLiverFxInit = true;

    var reduceMq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var canAnimateVars = !!(window.CSS && window.CSS.registerProperty);

    // wait (at most 1.2 s) until the glow and liver layers are decoded so nothing pops in mid-animation
    function layersReady(el) {
      var imgs = el.querySelectorAll('.cova-problem-checklist__stage img');
      var jobs = [];
      for (var i = 0; i < imgs.length; i++) {
        if (imgs[i].decode) jobs.push(imgs[i].decode().catch(function () {}));
      }
      var cap = new Promise(function (resolve) {
        setTimeout(resolve, 1200);
      });
      return Promise.race([Promise.all(jobs), cap]);
    }

    function play(el) {
      layersReady(el).then(function () {
        el.classList.add('is-playing');
      });
    }

    function arm(root) {
      var list = (root || document).querySelectorAll('[data-cova-liver-fx]');
      Array.prototype.forEach.call(list, function (el) {
        if (el.getAttribute('data-cova-fx-state')) return;
        el.setAttribute('data-cova-fx-state', 'armed');
        if (!canAnimateVars) el.classList.add('is-simple');
        if ((reduceMq && reduceMq.matches) || !('IntersectionObserver' in window)) {
          el.classList.add('is-done');
          return;
        }
        var io = new IntersectionObserver(
          function (entries) {
            for (var i = 0; i < entries.length; i++) {
              if (entries[i].isIntersecting) {
                io.disconnect();
                play(el);
                break;
              }
            }
          },
          { threshold: 0.6 }
        );
        io.observe(el);
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { arm(); });
    else arm();

    // theme editor: re-arm a re-rendered section, and replay when it is selected
    document.addEventListener('shopify:section:load', function (e) { arm(e.target); });
    document.addEventListener('shopify:section:select', function (e) {
      var el = e.target && e.target.querySelector ? e.target.querySelector('[data-cova-liver-fx]') : null;
      if (!el || !el.classList.contains('is-playing')) return;
      el.classList.remove('is-playing');
      void el.offsetWidth;
      el.classList.add('is-playing');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resetter-proven-stats"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.CovaStatsCountInit) return;
    window.CovaStatsCountInit = true;

    var DURATION = 1400; // ms, ease-out
    var STAGGER = 140; // ms between the cards
    var reduceMq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    function esc(t) {
      return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    // "93%" -> prefix "", number "93", suffix "%". Anything else (no number, thousands separators) stays as is.
    function parse(text) {
      var m = /^(\D*?)(\d+(?:\.\d+)?)(\D*)$/.exec(text);
      if (!m) return null;
      var dot = m[2].indexOf('.');
      return { pre: m[1], post: m[3], value: parseFloat(m[2]), decimals: dot < 0 ? 0 : m[2].length - dot - 1 };
    }

    // Pin the box to the width of the final text (so nothing around it can move), then show the start value.
    function prepare(el) {
      var finalText = el.textContent.trim();
      var info = parse(finalText);
      if (!info) return null;
      el.style.minWidth = Math.ceil(el.getBoundingClientRect().width * 100) / 100 + 'px';
      el.innerHTML = '<span class="cova-visually-hidden">' + esc(finalText) + '</span><span aria-hidden="true"></span>';
      var job = { el: el, text: el.lastChild, finalText: finalText, info: info };
      show(job, 0);
      return job;
    }

    function show(job, value) {
      job.text.textContent = job.info.pre + value.toFixed(job.info.decimals) + job.info.post;
    }

    function run(jobs) {
      var t0 = null;
      function frame(now) {
        if (t0 === null) t0 = now;
        var running = false;
        for (var i = 0; i < jobs.length; i++) {
          var job = jobs[i];
          if (job.done) continue;
          var p = (now - t0 - i * STAGGER) / DURATION;
          if (p >= 1) {
            job.done = true;
            job.el.textContent = job.finalText; // the text exactly as authored in the setting
            continue;
          }
          running = true;
          p = p < 0 ? 0 : p;
          show(job, job.info.value * (1 - Math.pow(1 - p, 3)));
        }
        if (running) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    function arm(root) {
      var sections = (root || document).querySelectorAll('[data-cova-proven-stats]');
      Array.prototype.forEach.call(sections, function (section) {
        if (section.getAttribute('data-cova-count-state')) return;
        section.setAttribute('data-cova-count-state', 'armed');
        if ((reduceMq && reduceMq.matches) || !('IntersectionObserver' in window)) return;
        var els = section.querySelectorAll('[data-cova-count]');
        if (!els.length) return;
        var fontsReady = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
        var jobs = null;
        var seen = false;
        fontsReady.then(function () {
          // measure once the font is loaded, then park every number at 0 until the section is seen
          jobs = [];
          Array.prototype.forEach.call(els, function (el) {
            var job = prepare(el);
            if (job) jobs.push(job);
          });
          if (seen && jobs.length) run(jobs);
        });
        var io = new IntersectionObserver(
          function (entries) {
            for (var i = 0; i < entries.length; i++) {
              if (!entries[i].isIntersecting) continue;
              io.disconnect();
              seen = true;
              if (jobs && jobs.length) run(jobs);
              break;
            }
          },
          { threshold: 0.3 }
        );
        io.observe(section);
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { arm(); });
    else arm();
    document.addEventListener('shopify:section:load', function (e) { arm(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resetter-scratch-popup"]) return;
  try {
    
  (function () {
    'use strict';
    if (window.CovaPopup) {
      window.CovaPopup.init(document);
      return;
    }

    var SEEN_KEY = 'cova:popup-seen';
    var BRUSH = 46; // scratch brush width in CSS px
    var THRESHOLD = 0.5; // share of the coating that has to go before the prize is revealed
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    function storageGet(key) {
      try {
        return window.localStorage.getItem(key);
      } catch (e) {
        return null;
      }
    }
    function storageSet(key, value) {
      try {
        window.localStorage.setItem(key, value);
      } catch (e) {}
    }
    function blocked() {
      var html = document.documentElement;
      return html.hasAttribute('data-cova-no-popup') || (document.body && document.body.hasAttribute('data-cova-no-popup'));
    }
    function designMode() {
      return !!(window.Shopify && window.Shopify.designMode);
    }
    function q(root, name) {
      return root.querySelector('[data-cova-popup-' + name + ']');
    }
    function reduceMotion() {
      try {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) {
        return false;
      }
    }

    /* ---------------------------------------------------------------- gold coating */
    function roundRect(ctx, x, y, w, h, r) {
      ctx.beginPath();
      ctx.moveTo(x + r, y);
      ctx.arcTo(x + w, y, x + w, y + h, r);
      ctx.arcTo(x + w, y + h, x, y + h, r);
      ctx.arcTo(x, y + h, x, y, r);
      ctx.arcTo(x, y, x + w, y, r);
      ctx.closePath();
    }

    function paintCoating(ctx, w, h, label) {
      ctx.globalCompositeOperation = 'source-over';
      var g = ctx.createLinearGradient(0, 0, w, h);
      g.addColorStop(0, '#f6d982');
      g.addColorStop(0.28, '#e4bc5d');
      g.addColorStop(0.5, '#f3d47c');
      g.addColorStop(0.74, '#d6aa45');
      g.addColorStop(1, '#ebc869');
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, w, h);

      // soft light sweep, like foil catching light
      var sweep = ctx.createLinearGradient(0, h * 0.15, w, h * 0.05);
      sweep.addColorStop(0, 'rgba(255,255,255,0)');
      sweep.addColorStop(0.5, 'rgba(255,255,255,0.22)');
      sweep.addColorStop(1, 'rgba(255,255,255,0)');
      ctx.fillStyle = sweep;
      ctx.fillRect(0, 0, w, h * 0.6);

      // fine grain
      var specks = Math.round((w * h) / 48);
      for (var i = 0; i < specks; i++) {
        var x = Math.random() * w;
        var y = Math.random() * h;
        var dark = Math.random() < 0.45;
        ctx.fillStyle = dark ? 'rgba(120,86,20,' + (0.04 + Math.random() * 0.1) + ')' : 'rgba(255,248,214,' + (0.08 + Math.random() * 0.2) + ')';
        var s = 0.5 + Math.random() * 1.3;
        ctx.fillRect(x, y, s, s);
      }

      // darker brush strokes behind the label
      ctx.save();
      ctx.globalAlpha = 0.17;
      ctx.fillStyle = '#6d5220';
      for (var k = 0; k < 5; k++) {
        ctx.save();
        ctx.translate(w * (0.2 + 0.15 * k), h * 0.56);
        ctx.rotate(-0.3);
        roundRect(ctx, -w * 0.045, -h * 0.27, w * 0.095, h * 0.54, w * 0.02);
        ctx.fill();
        ctx.restore();
      }
      ctx.restore();

      // label
      var size = Math.min(36, w * 0.105);
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      var family = 'Figtree, system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif';
      ctx.font = '800 ' + size + 'px ' + family;
      while (size > 14 && ctx.measureText(label).width > w * 0.84) {
        size -= 1;
        ctx.font = '800 ' + size + 'px ' + family;
      }
      ctx.save();
      ctx.shadowColor = 'rgba(110,80,20,0.35)';
      ctx.shadowBlur = 3;
      ctx.shadowOffsetY = 1;
      ctx.fillStyle = 'rgba(255,250,232,0.66)';
      ctx.fillText(label, w / 2, h / 2 + 1);
      ctx.restore();
    }

    /* ---------------------------------------------------------------- one popup */
    function setup(root) {
      if (root.covaPopup) return;
      var card = q(root, 'card');
      var canvas = q(root, 'canvas');
      var reveal = q(root, 'reveal');
      var claimBtn = q(root, 'claim');
      var form = q(root, 'form');
      var email = q(root, 'email');
      var errorLine = q(root, 'error-line');
      var success = q(root, 'success');
      var closeBtn = q(root, 'close');
      if (!card || !canvas || !closeBtn) return;

      var delay = parseFloat(root.getAttribute('data-cova-popup-delay'));
      if (isNaN(delay) || delay < 0) delay = 10;
      var amount = root.getAttribute('data-cova-popup-amount') || '';
      var errorText = root.getAttribute('data-cova-popup-error') || '';
      var closeLabel = root.getAttribute('data-cova-popup-close-label') || '';
      var label = canvas.getAttribute('data-cova-popup-label') || '';
      var ctx = canvas.getContext ? canvas.getContext('2d', { willReadFrequently: true }) : null;

      var st = { open: false, done: false, touched: false, drawing: false, last: null, lastCheck: 0, w: 0, h: 0, dpr: 1, timer: 0, prevFocus: null, claimed: false };

      function prepare() {
        if (!ctx) {
          finish();
          return;
        }
        var rect = card.getBoundingClientRect();
        if (!rect.width) return;
        st.dpr = Math.min(window.devicePixelRatio || 1, 2);
        st.w = Math.round(rect.width);
        st.h = Math.round(rect.height);
        canvas.width = Math.round(st.w * st.dpr);
        canvas.height = Math.round(st.h * st.dpr);
        ctx.setTransform(st.dpr, 0, 0, st.dpr, 0, 0);
        ctx.clearRect(0, 0, st.w, st.h);
        paintCoating(ctx, st.w, st.h, label);
        st.touched = false;
      }

      function point(e) {
        var r = canvas.getBoundingClientRect();
        return { x: ((e.clientX - r.left) / r.width) * st.w, y: ((e.clientY - r.top) / r.height) * st.h };
      }
      function stroke(from, to) {
        ctx.globalCompositeOperation = 'destination-out';
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.lineWidth = BRUSH;
        ctx.beginPath();
        ctx.moveTo(from.x, from.y);
        ctx.lineTo(to.x, to.y);
        ctx.stroke();
        ctx.globalCompositeOperation = 'source-over';
      }
      function cleared() {
        var cw = canvas.width;
        var ch = canvas.height;
        var data;
        try {
          data = ctx.getImageData(0, 0, cw, ch).data;
        } catch (e) {
          return 0;
        }
        var step = Math.max(4, Math.round(st.dpr * 4));
        var total = 0;
        var gone = 0;
        for (var y = 0; y < ch; y += step) {
          for (var x = 0; x < cw; x += step) {
            total++;
            if (data[(y * cw + x) * 4 + 3] < 40) gone++;
          }
        }
        return total ? gone / total : 0;
      }
      function check() {
        st.lastCheck = Date.now();
        if (!st.done && cleared() >= THRESHOLD) finish();
      }

      function finish() {
        if (st.done) return;
        st.done = true;
        st.drawing = false;
        canvas.classList.add('is-cleared');
        canvas.setAttribute('aria-hidden', 'true');
        canvas.tabIndex = -1;
        if (reveal) {
          reveal.hidden = false;
          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
              reveal.classList.add('is-shown');
            });
          });
        }
      }

      canvas.addEventListener('pointerdown', function (e) {
        if (st.done || !ctx) return;
        e.preventDefault();
        try {
          canvas.setPointerCapture(e.pointerId);
        } catch (err) {}
        st.drawing = true;
        st.touched = true;
        st.last = point(e);
        stroke(st.last, st.last);
      });
      canvas.addEventListener('pointermove', function (e) {
        if (!st.drawing || st.done) return;
        e.preventDefault();
        var p = point(e);
        stroke(st.last, p);
        st.last = p;
        if (Date.now() - st.lastCheck > 90) check();
      });
      function stop() {
        if (!st.drawing) return;
        st.drawing = false;
        check();
      }
      canvas.addEventListener('pointerup', stop);
      canvas.addEventListener('pointercancel', stop);
      canvas.addEventListener('lostpointercapture', stop);
      canvas.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (ctx) ctx.clearRect(0, 0, st.w, st.h);
          finish();
        }
      });

      if (claimBtn && form) {
        claimBtn.addEventListener('click', function () {
          claimBtn.hidden = true;
          form.hidden = false;
          if (email) email.focus();
        });
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var value = (email ? email.value : '').trim();
          if (!EMAIL_RE.test(value)) {
            if (errorLine) {
              errorLine.textContent = errorText;
              errorLine.hidden = false;
            }
            if (email) {
              email.setAttribute('aria-invalid', 'true');
              email.focus();
            }
            return;
          }
          if (errorLine) errorLine.hidden = true;
          if (email) email.removeAttribute('aria-invalid');
          st.claimed = true;
          form.hidden = true;
          if (success) success.hidden = false;
          if (closeLabel) closeBtn.textContent = closeLabel;
          // The email is sent by a separate integration that listens for this event.
          root.dispatchEvent(new CustomEvent('cova:discount-claimed', { bubbles: true, detail: { email: value, discount: amount, source: 'scratch-popup' } }));
        });
        if (email) {
          email.addEventListener('input', function () {
            if (errorLine) errorLine.hidden = true;
            email.removeAttribute('aria-invalid');
          });
        }
      }

      function focusables() {
        return Array.prototype.slice.call(root.querySelectorAll('button, input, [tabindex="0"]')).filter(function (el) {
          return !el.disabled && !el.hidden && !el.closest('[hidden]') && el.getAttribute('aria-hidden') !== 'true' && el.tabIndex >= 0;
        });
      }
      function onKey(e) {
        if (!st.open) return;
        if (e.key === 'Escape') {
          e.preventDefault();
          close();
          return;
        }
        if (e.key !== 'Tab') return;
        var list = focusables();
        if (!list.length) return;
        var first = list[0];
        var last = list[list.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === root)) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
      var resizeRaf = 0;
      function onResize() {
        if (!st.open || st.touched || st.done) return;
        if (resizeRaf) return;
        resizeRaf = window.requestAnimationFrame(function () {
          resizeRaf = 0;
          prepare();
        });
      }

      function open(opts) {
        if (st.open) return;
        opts = opts || {};
        st.open = true;
        window.clearTimeout(st.timer);
        st.prevFocus = document.activeElement;
        root.hidden = false;
        document.documentElement.classList.add('cova-popup-lock');
        if (!opts.preview) storageSet(SEEN_KEY, '1');
        // make sure the label font is ready before the coating is painted
        var ready = document.fonts && document.fonts.load ? document.fonts.load('800 36px Figtree') : null;
        var go = function () {
          if (st.open && !st.touched && !st.done) prepare();
        };
        prepare();
        if (ready && ready.then) ready.then(go, go);
        window.requestAnimationFrame(function () {
          root.classList.add('is-open');
        });
        try {
          root.focus({ preventScroll: true });
        } catch (e) {
          root.focus();
        }
        document.addEventListener('keydown', onKey);
        window.addEventListener('resize', onResize);
        root.dispatchEvent(new CustomEvent('cova:popup-open', { bubbles: true }));
      }

      function close() {
        if (!st.open) return;
        st.open = false;
        root.classList.remove('is-open');
        document.removeEventListener('keydown', onKey);
        window.removeEventListener('resize', onResize);
        var hide = function () {
          if (st.open) return;
          root.hidden = true;
          document.documentElement.classList.remove('cova-popup-lock');
        };
        if (reduceMotion()) hide();
        else window.setTimeout(hide, 360);
        var back = st.prevFocus;
        if (back && back.focus && document.contains(back)) {
          try {
            back.focus({ preventScroll: true });
          } catch (e) {}
        }
        root.dispatchEvent(new CustomEvent('cova:popup-close', { bubbles: true, detail: { claimed: st.claimed } }));
      }

      closeBtn.addEventListener('click', close);

      function schedule() {
        if (designMode()) return; // in the theme editor the popup opens when the section is selected
        if (blocked() || storageGet(SEEN_KEY)) return;
        st.timer = window.setTimeout(function () {
          if (blocked() || storageGet(SEEN_KEY)) return;
          open();
        }, delay * 1000);
      }
      schedule();

      root.covaPopup = { open: open, close: close };
    }

    function init(scope) {
      var list = (scope || document).querySelectorAll('[data-cova-popup]');
      for (var i = 0; i < list.length; i++) setup(list[i]);
    }

    window.CovaPopup = { init: init };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:section:select', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('[data-cova-popup]') : null;
      if (root && root.covaPopup) root.covaPopup.open({ preview: true });
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('[data-cova-popup]') : null;
      if (root && root.covaPopup) root.covaPopup.close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resetter-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.CovaVideoInit) return;
    window.CovaVideoInit = true;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-cova-video-play]') : null;
      if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
      var frame = btn.closest('[data-cova-video]');
      if (!frame) return;
      var video = frame.querySelector('video');
      var embed = frame.getAttribute('data-embed');
      if (video) {
        video.controls = true;
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
        frame.classList.add('is-playing');
      } else if (embed) {
        var stage = frame.querySelector('[data-cova-video-stage]');
        if (!stage) return;
        var frameEl = document.createElement('iframe');
        frameEl.src = embed;
        frameEl.allow = 'autoplay; fullscreen; picture-in-picture';
        frameEl.setAttribute('allowfullscreen', '');
        frameEl.title = btn.getAttribute('aria-label') || 'Video';
        stage.appendChild(frameEl);
        frame.classList.add('is-playing');
      }
    });

    // when a video ends, show the poster and play button again
    document.addEventListener(
      'ended',
      function (e) {
        var frame = e.target.closest ? e.target.closest('[data-cova-video]') : null;
        if (!frame) return;
        e.target.controls = false;
        frame.classList.remove('is-playing');
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["safety-comic-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    if (window.CovaHeroGallery) return;

    function initGallery(root) {
      if (root.dataset.covaGalleryInit) return;
      var track = root.querySelector('[data-cova-gallery-track]');
      var list = root.querySelector('[data-cova-gallery-list]');
      var wrap = root.querySelector('[data-cova-gallery-thumbs]');
      if (!track || !list || !wrap) return;
      root.dataset.covaGalleryInit = '1';
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-cova-gallery-thumb]'));
      var clamp = root.hasAttribute('data-cova-gallery-clamp');
      var reduce = false;
      try {
        reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) {}
      var active = -1;
      var raf = 0;

      function pitch() {
        if (thumbs.length > 1) return thumbs[1].parentElement.offsetTop - thumbs[0].parentElement.offsetTop;
        return thumbs[0] ? thumbs[0].offsetHeight : 0;
      }
      function update() {
        raf = 0;
        var w = track.clientWidth || 1;
        var count = thumbs.length;
        var p = Math.max(0, Math.min(count - 1, track.scrollLeft / w));
        var shift = p * pitch();
        if (clamp) shift = Math.min(shift, Math.max(0, list.offsetHeight - wrap.clientHeight));
        list.style.transform = 'translate3d(0,' + -shift.toFixed(2) + 'px,0)';
        var i = Math.round(p);
        if (i !== active) {
          active = i;
          thumbs.forEach(function (t, n) {
            var on = n === i;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-current', on ? 'true' : 'false');
          });
        }
      }
      function queue() {
        if (!raf) raf = window.requestAnimationFrame(update);
      }
      function goTo(i) {
        track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      }

      track.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue);
      thumbs.forEach(function (t, n) {
        t.addEventListener('click', function () {
          goTo(n);
        });
      });
      if (window.ResizeObserver) new window.ResizeObserver(queue).observe(root);
      update();
    }

    function init(scope) {
      (scope || document).querySelectorAll('[data-cova-gallery]').forEach(initGallery);
    }
    window.CovaHeroGallery = { init: init };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["safety-comic-proven-stats"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.CovaStatsCountInit) return;
    window.CovaStatsCountInit = true;

    var DURATION = 1400; // ms, ease-out
    var STAGGER = 140; // ms between the cards
    var reduceMq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    function esc(t) {
      return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    // "93%" -> prefix "", number "93", suffix "%". Anything else (no number, thousands separators) stays as is.
    function parse(text) {
      var m = /^(\D*?)(\d+(?:\.\d+)?)(\D*)$/.exec(text);
      if (!m) return null;
      var dot = m[2].indexOf('.');
      return { pre: m[1], post: m[3], value: parseFloat(m[2]), decimals: dot < 0 ? 0 : m[2].length - dot - 1 };
    }

    // Pin the box to the width of the final text (so nothing around it can move), then show the start value.
    function prepare(el) {
      var finalText = el.textContent.trim();
      var info = parse(finalText);
      if (!info) return null;
      el.style.minWidth = Math.ceil(el.getBoundingClientRect().width * 100) / 100 + 'px';
      el.innerHTML = '<span class="cova-visually-hidden">' + esc(finalText) + '</span><span aria-hidden="true"></span>';
      var job = { el: el, text: el.lastChild, finalText: finalText, info: info };
      show(job, 0);
      return job;
    }

    function show(job, value) {
      job.text.textContent = job.info.pre + value.toFixed(job.info.decimals) + job.info.post;
    }

    function run(jobs) {
      var t0 = null;
      function frame(now) {
        if (t0 === null) t0 = now;
        var running = false;
        for (var i = 0; i < jobs.length; i++) {
          var job = jobs[i];
          if (job.done) continue;
          var p = (now - t0 - i * STAGGER) / DURATION;
          if (p >= 1) {
            job.done = true;
            job.el.textContent = job.finalText; // the text exactly as authored in the setting
            continue;
          }
          running = true;
          p = p < 0 ? 0 : p;
          show(job, job.info.value * (1 - Math.pow(1 - p, 3)));
        }
        if (running) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    function arm(root) {
      var sections = (root || document).querySelectorAll('[data-cova-proven-stats]');
      Array.prototype.forEach.call(sections, function (section) {
        if (section.getAttribute('data-cova-count-state')) return;
        section.setAttribute('data-cova-count-state', 'armed');
        if ((reduceMq && reduceMq.matches) || !('IntersectionObserver' in window)) return;
        var els = section.querySelectorAll('[data-cova-count]');
        if (!els.length) return;
        var fontsReady = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
        var jobs = null;
        var seen = false;
        fontsReady.then(function () {
          // measure once the font is loaded, then park every number at 0 until the section is seen
          jobs = [];
          Array.prototype.forEach.call(els, function (el) {
            var job = prepare(el);
            if (job) jobs.push(job);
          });
          if (seen && jobs.length) run(jobs);
        });
        var io = new IntersectionObserver(
          function (entries) {
            for (var i = 0; i < entries.length; i++) {
              if (!entries[i].isIntersecting) continue;
              io.disconnect();
              seen = true;
              if (jobs && jobs.length) run(jobs);
              break;
            }
          },
          { threshold: 0.3 }
        );
        io.observe(section);
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { arm(); });
    else arm();
    document.addEventListener('shopify:section:load', function (e) { arm(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["safety-comic-scratch-popup"]) return;
  try {
    
  (function () {
    'use strict';
    if (window.CovaPopup) {
      window.CovaPopup.init(document);
      return;
    }

    var SEEN_KEY = 'cova:popup-seen';
    var BRUSH = 46; // scratch brush width in CSS px
    var THRESHOLD = 0.5; // share of the coating that has to go before the prize is revealed
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    function storageGet(key) {
      try {
        return window.localStorage.getItem(key);
      } catch (e) {
        return null;
      }
    }
    function storageSet(key, value) {
      try {
        window.localStorage.setItem(key, value);
      } catch (e) {}
    }
    function blocked() {
      var html = document.documentElement;
      return html.hasAttribute('data-cova-no-popup') || (document.body && document.body.hasAttribute('data-cova-no-popup'));
    }
    function designMode() {
      return !!(window.Shopify && window.Shopify.designMode);
    }
    function q(root, name) {
      return root.querySelector('[data-cova-popup-' + name + ']');
    }
    function reduceMotion() {
      try {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) {
        return false;
      }
    }

    /* ---------------------------------------------------------------- gold coating */
    function roundRect(ctx, x, y, w, h, r) {
      ctx.beginPath();
      ctx.moveTo(x + r, y);
      ctx.arcTo(x + w, y, x + w, y + h, r);
      ctx.arcTo(x + w, y + h, x, y + h, r);
      ctx.arcTo(x, y + h, x, y, r);
      ctx.arcTo(x, y, x + w, y, r);
      ctx.closePath();
    }

    function paintCoating(ctx, w, h, label) {
      ctx.globalCompositeOperation = 'source-over';
      var g = ctx.createLinearGradient(0, 0, w, h);
      g.addColorStop(0, '#f6d982');
      g.addColorStop(0.28, '#e4bc5d');
      g.addColorStop(0.5, '#f3d47c');
      g.addColorStop(0.74, '#d6aa45');
      g.addColorStop(1, '#ebc869');
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, w, h);

      // soft light sweep, like foil catching light
      var sweep = ctx.createLinearGradient(0, h * 0.15, w, h * 0.05);
      sweep.addColorStop(0, 'rgba(255,255,255,0)');
      sweep.addColorStop(0.5, 'rgba(255,255,255,0.22)');
      sweep.addColorStop(1, 'rgba(255,255,255,0)');
      ctx.fillStyle = sweep;
      ctx.fillRect(0, 0, w, h * 0.6);

      // fine grain
      var specks = Math.round((w * h) / 48);
      for (var i = 0; i < specks; i++) {
        var x = Math.random() * w;
        var y = Math.random() * h;
        var dark = Math.random() < 0.45;
        ctx.fillStyle = dark ? 'rgba(120,86,20,' + (0.04 + Math.random() * 0.1) + ')' : 'rgba(255,248,214,' + (0.08 + Math.random() * 0.2) + ')';
        var s = 0.5 + Math.random() * 1.3;
        ctx.fillRect(x, y, s, s);
      }

      // darker brush strokes behind the label
      ctx.save();
      ctx.globalAlpha = 0.17;
      ctx.fillStyle = '#6d5220';
      for (var k = 0; k < 5; k++) {
        ctx.save();
        ctx.translate(w * (0.2 + 0.15 * k), h * 0.56);
        ctx.rotate(-0.3);
        roundRect(ctx, -w * 0.045, -h * 0.27, w * 0.095, h * 0.54, w * 0.02);
        ctx.fill();
        ctx.restore();
      }
      ctx.restore();

      // label
      var size = Math.min(36, w * 0.105);
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      var family = 'Figtree, system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif';
      ctx.font = '800 ' + size + 'px ' + family;
      while (size > 14 && ctx.measureText(label).width > w * 0.84) {
        size -= 1;
        ctx.font = '800 ' + size + 'px ' + family;
      }
      ctx.save();
      ctx.shadowColor = 'rgba(110,80,20,0.35)';
      ctx.shadowBlur = 3;
      ctx.shadowOffsetY = 1;
      ctx.fillStyle = 'rgba(255,250,232,0.66)';
      ctx.fillText(label, w / 2, h / 2 + 1);
      ctx.restore();
    }

    /* ---------------------------------------------------------------- one popup */
    function setup(root) {
      if (root.covaPopup) return;
      var card = q(root, 'card');
      var canvas = q(root, 'canvas');
      var reveal = q(root, 'reveal');
      var claimBtn = q(root, 'claim');
      var form = q(root, 'form');
      var email = q(root, 'email');
      var errorLine = q(root, 'error-line');
      var success = q(root, 'success');
      var closeBtn = q(root, 'close');
      if (!card || !canvas || !closeBtn) return;

      var delay = parseFloat(root.getAttribute('data-cova-popup-delay'));
      if (isNaN(delay) || delay < 0) delay = 10;
      var amount = root.getAttribute('data-cova-popup-amount') || '';
      var errorText = root.getAttribute('data-cova-popup-error') || '';
      var closeLabel = root.getAttribute('data-cova-popup-close-label') || '';
      var label = canvas.getAttribute('data-cova-popup-label') || '';
      var ctx = canvas.getContext ? canvas.getContext('2d', { willReadFrequently: true }) : null;

      var st = { open: false, done: false, touched: false, drawing: false, last: null, lastCheck: 0, w: 0, h: 0, dpr: 1, timer: 0, prevFocus: null, claimed: false };

      function prepare() {
        if (!ctx) {
          finish();
          return;
        }
        var rect = card.getBoundingClientRect();
        if (!rect.width) return;
        st.dpr = Math.min(window.devicePixelRatio || 1, 2);
        st.w = Math.round(rect.width);
        st.h = Math.round(rect.height);
        canvas.width = Math.round(st.w * st.dpr);
        canvas.height = Math.round(st.h * st.dpr);
        ctx.setTransform(st.dpr, 0, 0, st.dpr, 0, 0);
        ctx.clearRect(0, 0, st.w, st.h);
        paintCoating(ctx, st.w, st.h, label);
        st.touched = false;
      }

      function point(e) {
        var r = canvas.getBoundingClientRect();
        return { x: ((e.clientX - r.left) / r.width) * st.w, y: ((e.clientY - r.top) / r.height) * st.h };
      }
      function stroke(from, to) {
        ctx.globalCompositeOperation = 'destination-out';
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.lineWidth = BRUSH;
        ctx.beginPath();
        ctx.moveTo(from.x, from.y);
        ctx.lineTo(to.x, to.y);
        ctx.stroke();
        ctx.globalCompositeOperation = 'source-over';
      }
      function cleared() {
        var cw = canvas.width;
        var ch = canvas.height;
        var data;
        try {
          data = ctx.getImageData(0, 0, cw, ch).data;
        } catch (e) {
          return 0;
        }
        var step = Math.max(4, Math.round(st.dpr * 4));
        var total = 0;
        var gone = 0;
        for (var y = 0; y < ch; y += step) {
          for (var x = 0; x < cw; x += step) {
            total++;
            if (data[(y * cw + x) * 4 + 3] < 40) gone++;
          }
        }
        return total ? gone / total : 0;
      }
      function check() {
        st.lastCheck = Date.now();
        if (!st.done && cleared() >= THRESHOLD) finish();
      }

      function finish() {
        if (st.done) return;
        st.done = true;
        st.drawing = false;
        canvas.classList.add('is-cleared');
        canvas.setAttribute('aria-hidden', 'true');
        canvas.tabIndex = -1;
        if (reveal) {
          reveal.hidden = false;
          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
              reveal.classList.add('is-shown');
            });
          });
        }
      }

      canvas.addEventListener('pointerdown', function (e) {
        if (st.done || !ctx) return;
        e.preventDefault();
        try {
          canvas.setPointerCapture(e.pointerId);
        } catch (err) {}
        st.drawing = true;
        st.touched = true;
        st.last = point(e);
        stroke(st.last, st.last);
      });
      canvas.addEventListener('pointermove', function (e) {
        if (!st.drawing || st.done) return;
        e.preventDefault();
        var p = point(e);
        stroke(st.last, p);
        st.last = p;
        if (Date.now() - st.lastCheck > 90) check();
      });
      function stop() {
        if (!st.drawing) return;
        st.drawing = false;
        check();
      }
      canvas.addEventListener('pointerup', stop);
      canvas.addEventListener('pointercancel', stop);
      canvas.addEventListener('lostpointercapture', stop);
      canvas.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (ctx) ctx.clearRect(0, 0, st.w, st.h);
          finish();
        }
      });

      if (claimBtn && form) {
        claimBtn.addEventListener('click', function () {
          claimBtn.hidden = true;
          form.hidden = false;
          if (email) email.focus();
        });
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var value = (email ? email.value : '').trim();
          if (!EMAIL_RE.test(value)) {
            if (errorLine) {
              errorLine.textContent = errorText;
              errorLine.hidden = false;
            }
            if (email) {
              email.setAttribute('aria-invalid', 'true');
              email.focus();
            }
            return;
          }
          if (errorLine) errorLine.hidden = true;
          if (email) email.removeAttribute('aria-invalid');
          st.claimed = true;
          form.hidden = true;
          if (success) success.hidden = false;
          if (closeLabel) closeBtn.textContent = closeLabel;
          // The email is sent by a separate integration that listens for this event.
          root.dispatchEvent(new CustomEvent('cova:discount-claimed', { bubbles: true, detail: { email: value, discount: amount, source: 'scratch-popup' } }));
        });
        if (email) {
          email.addEventListener('input', function () {
            if (errorLine) errorLine.hidden = true;
            email.removeAttribute('aria-invalid');
          });
        }
      }

      function focusables() {
        return Array.prototype.slice.call(root.querySelectorAll('button, input, [tabindex="0"]')).filter(function (el) {
          return !el.disabled && !el.hidden && !el.closest('[hidden]') && el.getAttribute('aria-hidden') !== 'true' && el.tabIndex >= 0;
        });
      }
      function onKey(e) {
        if (!st.open) return;
        if (e.key === 'Escape') {
          e.preventDefault();
          close();
          return;
        }
        if (e.key !== 'Tab') return;
        var list = focusables();
        if (!list.length) return;
        var first = list[0];
        var last = list[list.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === root)) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
      var resizeRaf = 0;
      function onResize() {
        if (!st.open || st.touched || st.done) return;
        if (resizeRaf) return;
        resizeRaf = window.requestAnimationFrame(function () {
          resizeRaf = 0;
          prepare();
        });
      }

      function open(opts) {
        if (st.open) return;
        opts = opts || {};
        st.open = true;
        window.clearTimeout(st.timer);
        st.prevFocus = document.activeElement;
        root.hidden = false;
        document.documentElement.classList.add('cova-popup-lock');
        if (!opts.preview) storageSet(SEEN_KEY, '1');
        // make sure the label font is ready before the coating is painted
        var ready = document.fonts && document.fonts.load ? document.fonts.load('800 36px Figtree') : null;
        var go = function () {
          if (st.open && !st.touched && !st.done) prepare();
        };
        prepare();
        if (ready && ready.then) ready.then(go, go);
        window.requestAnimationFrame(function () {
          root.classList.add('is-open');
        });
        try {
          root.focus({ preventScroll: true });
        } catch (e) {
          root.focus();
        }
        document.addEventListener('keydown', onKey);
        window.addEventListener('resize', onResize);
        root.dispatchEvent(new CustomEvent('cova:popup-open', { bubbles: true }));
      }

      function close() {
        if (!st.open) return;
        st.open = false;
        root.classList.remove('is-open');
        document.removeEventListener('keydown', onKey);
        window.removeEventListener('resize', onResize);
        var hide = function () {
          if (st.open) return;
          root.hidden = true;
          document.documentElement.classList.remove('cova-popup-lock');
        };
        if (reduceMotion()) hide();
        else window.setTimeout(hide, 360);
        var back = st.prevFocus;
        if (back && back.focus && document.contains(back)) {
          try {
            back.focus({ preventScroll: true });
          } catch (e) {}
        }
        root.dispatchEvent(new CustomEvent('cova:popup-close', { bubbles: true, detail: { claimed: st.claimed } }));
      }

      closeBtn.addEventListener('click', close);

      function schedule() {
        if (designMode()) return; // in the theme editor the popup opens when the section is selected
        if (blocked() || storageGet(SEEN_KEY)) return;
        st.timer = window.setTimeout(function () {
          if (blocked() || storageGet(SEEN_KEY)) return;
          open();
        }, delay * 1000);
      }
      schedule();

      root.covaPopup = { open: open, close: close };
    }

    function init(scope) {
      var list = (scope || document).querySelectorAll('[data-cova-popup]');
      for (var i = 0; i < list.length; i++) setup(list[i]);
    }

    window.CovaPopup = { init: init };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:section:select', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('[data-cova-popup]') : null;
      if (root && root.covaPopup) root.covaPopup.open({ preview: true });
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('[data-cova-popup]') : null;
      if (root && root.covaPopup) root.covaPopup.close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["safety-comic-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.CovaVideoInit) return;
    window.CovaVideoInit = true;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-cova-video-play]') : null;
      if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
      var frame = btn.closest('[data-cova-video]');
      if (!frame) return;
      var video = frame.querySelector('video');
      var embed = frame.getAttribute('data-embed');
      if (video) {
        video.controls = true;
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
        frame.classList.add('is-playing');
      } else if (embed) {
        var stage = frame.querySelector('[data-cova-video-stage]');
        if (!stage) return;
        var frameEl = document.createElement('iframe');
        frameEl.src = embed;
        frameEl.allow = 'autoplay; fullscreen; picture-in-picture';
        frameEl.setAttribute('allowfullscreen', '');
        frameEl.title = btn.getAttribute('aria-label') || 'Video';
        stage.appendChild(frameEl);
        frame.classList.add('is-playing');
      }
    });

    // when a video ends, show the poster and play button again
    document.addEventListener(
      'ended',
      function (e) {
        var frame = e.target.closest ? e.target.closest('[data-cova-video]') : null;
        if (!frame) return;
        e.target.controls = false;
        frame.classList.remove('is-playing');
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sewing-machine-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    if (window.CovaHeroGallery) return;

    function initGallery(root) {
      if (root.dataset.covaGalleryInit) return;
      var track = root.querySelector('[data-cova-gallery-track]');
      var list = root.querySelector('[data-cova-gallery-list]');
      var wrap = root.querySelector('[data-cova-gallery-thumbs]');
      if (!track || !list || !wrap) return;
      root.dataset.covaGalleryInit = '1';
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-cova-gallery-thumb]'));
      var clamp = root.hasAttribute('data-cova-gallery-clamp');
      var reduce = false;
      try {
        reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) {}
      var active = -1;
      var raf = 0;

      function pitch() {
        if (thumbs.length > 1) return thumbs[1].parentElement.offsetTop - thumbs[0].parentElement.offsetTop;
        return thumbs[0] ? thumbs[0].offsetHeight : 0;
      }
      function update() {
        raf = 0;
        var w = track.clientWidth || 1;
        var count = thumbs.length;
        var p = Math.max(0, Math.min(count - 1, track.scrollLeft / w));
        var shift = p * pitch();
        if (clamp) shift = Math.min(shift, Math.max(0, list.offsetHeight - wrap.clientHeight));
        list.style.transform = 'translate3d(0,' + -shift.toFixed(2) + 'px,0)';
        var i = Math.round(p);
        if (i !== active) {
          active = i;
          thumbs.forEach(function (t, n) {
            var on = n === i;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-current', on ? 'true' : 'false');
          });
        }
      }
      function queue() {
        if (!raf) raf = window.requestAnimationFrame(update);
      }
      function goTo(i) {
        track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      }

      track.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue);
      thumbs.forEach(function (t, n) {
        t.addEventListener('click', function () {
          goTo(n);
        });
      });
      if (window.ResizeObserver) new window.ResizeObserver(queue).observe(root);
      update();
    }

    function init(scope) {
      (scope || document).querySelectorAll('[data-cova-gallery]').forEach(initGallery);
    }
    window.CovaHeroGallery = { init: init };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sewing-machine-proven-stats"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.CovaStatsCountInit) return;
    window.CovaStatsCountInit = true;

    var DURATION = 1400; // ms, ease-out
    var STAGGER = 140; // ms between the cards
    var reduceMq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    function esc(t) {
      return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    // "93%" -> prefix "", number "93", suffix "%". Anything else (no number, thousands separators) stays as is.
    function parse(text) {
      var m = /^(\D*?)(\d+(?:\.\d+)?)(\D*)$/.exec(text);
      if (!m) return null;
      var dot = m[2].indexOf('.');
      return { pre: m[1], post: m[3], value: parseFloat(m[2]), decimals: dot < 0 ? 0 : m[2].length - dot - 1 };
    }

    // Pin the box to the width of the final text (so nothing around it can move), then show the start value.
    function prepare(el) {
      var finalText = el.textContent.trim();
      var info = parse(finalText);
      if (!info) return null;
      el.style.minWidth = Math.ceil(el.getBoundingClientRect().width * 100) / 100 + 'px';
      el.innerHTML = '<span class="cova-visually-hidden">' + esc(finalText) + '</span><span aria-hidden="true"></span>';
      var job = { el: el, text: el.lastChild, finalText: finalText, info: info };
      show(job, 0);
      return job;
    }

    function show(job, value) {
      job.text.textContent = job.info.pre + value.toFixed(job.info.decimals) + job.info.post;
    }

    function run(jobs) {
      var t0 = null;
      function frame(now) {
        if (t0 === null) t0 = now;
        var running = false;
        for (var i = 0; i < jobs.length; i++) {
          var job = jobs[i];
          if (job.done) continue;
          var p = (now - t0 - i * STAGGER) / DURATION;
          if (p >= 1) {
            job.done = true;
            job.el.textContent = job.finalText; // the text exactly as authored in the setting
            continue;
          }
          running = true;
          p = p < 0 ? 0 : p;
          show(job, job.info.value * (1 - Math.pow(1 - p, 3)));
        }
        if (running) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    function arm(root) {
      var sections = (root || document).querySelectorAll('[data-cova-proven-stats]');
      Array.prototype.forEach.call(sections, function (section) {
        if (section.getAttribute('data-cova-count-state')) return;
        section.setAttribute('data-cova-count-state', 'armed');
        if ((reduceMq && reduceMq.matches) || !('IntersectionObserver' in window)) return;
        var els = section.querySelectorAll('[data-cova-count]');
        if (!els.length) return;
        var fontsReady = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
        var jobs = null;
        var seen = false;
        fontsReady.then(function () {
          // measure once the font is loaded, then park every number at 0 until the section is seen
          jobs = [];
          Array.prototype.forEach.call(els, function (el) {
            var job = prepare(el);
            if (job) jobs.push(job);
          });
          if (seen && jobs.length) run(jobs);
        });
        var io = new IntersectionObserver(
          function (entries) {
            for (var i = 0; i < entries.length; i++) {
              if (!entries[i].isIntersecting) continue;
              io.disconnect();
              seen = true;
              if (jobs && jobs.length) run(jobs);
              break;
            }
          },
          { threshold: 0.3 }
        );
        io.observe(section);
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { arm(); });
    else arm();
    document.addEventListener('shopify:section:load', function (e) { arm(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sewing-machine-scratch-popup"]) return;
  try {
    
  (function () {
    'use strict';
    if (window.CovaPopup) {
      window.CovaPopup.init(document);
      return;
    }

    var SEEN_KEY = 'cova:popup-seen';
    var BRUSH = 46; // scratch brush width in CSS px
    var THRESHOLD = 0.5; // share of the coating that has to go before the prize is revealed
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    function storageGet(key) {
      try {
        return window.localStorage.getItem(key);
      } catch (e) {
        return null;
      }
    }
    function storageSet(key, value) {
      try {
        window.localStorage.setItem(key, value);
      } catch (e) {}
    }
    function blocked() {
      var html = document.documentElement;
      return html.hasAttribute('data-cova-no-popup') || (document.body && document.body.hasAttribute('data-cova-no-popup'));
    }
    function designMode() {
      return !!(window.Shopify && window.Shopify.designMode);
    }
    function q(root, name) {
      return root.querySelector('[data-cova-popup-' + name + ']');
    }
    function reduceMotion() {
      try {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) {
        return false;
      }
    }

    /* ---------------------------------------------------------------- gold coating */
    function roundRect(ctx, x, y, w, h, r) {
      ctx.beginPath();
      ctx.moveTo(x + r, y);
      ctx.arcTo(x + w, y, x + w, y + h, r);
      ctx.arcTo(x + w, y + h, x, y + h, r);
      ctx.arcTo(x, y + h, x, y, r);
      ctx.arcTo(x, y, x + w, y, r);
      ctx.closePath();
    }

    function paintCoating(ctx, w, h, label) {
      ctx.globalCompositeOperation = 'source-over';
      var g = ctx.createLinearGradient(0, 0, w, h);
      g.addColorStop(0, '#f6d982');
      g.addColorStop(0.28, '#e4bc5d');
      g.addColorStop(0.5, '#f3d47c');
      g.addColorStop(0.74, '#d6aa45');
      g.addColorStop(1, '#ebc869');
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, w, h);

      // soft light sweep, like foil catching light
      var sweep = ctx.createLinearGradient(0, h * 0.15, w, h * 0.05);
      sweep.addColorStop(0, 'rgba(255,255,255,0)');
      sweep.addColorStop(0.5, 'rgba(255,255,255,0.22)');
      sweep.addColorStop(1, 'rgba(255,255,255,0)');
      ctx.fillStyle = sweep;
      ctx.fillRect(0, 0, w, h * 0.6);

      // fine grain
      var specks = Math.round((w * h) / 48);
      for (var i = 0; i < specks; i++) {
        var x = Math.random() * w;
        var y = Math.random() * h;
        var dark = Math.random() < 0.45;
        ctx.fillStyle = dark ? 'rgba(120,86,20,' + (0.04 + Math.random() * 0.1) + ')' : 'rgba(255,248,214,' + (0.08 + Math.random() * 0.2) + ')';
        var s = 0.5 + Math.random() * 1.3;
        ctx.fillRect(x, y, s, s);
      }

      // darker brush strokes behind the label
      ctx.save();
      ctx.globalAlpha = 0.17;
      ctx.fillStyle = '#6d5220';
      for (var k = 0; k < 5; k++) {
        ctx.save();
        ctx.translate(w * (0.2 + 0.15 * k), h * 0.56);
        ctx.rotate(-0.3);
        roundRect(ctx, -w * 0.045, -h * 0.27, w * 0.095, h * 0.54, w * 0.02);
        ctx.fill();
        ctx.restore();
      }
      ctx.restore();

      // label
      var size = Math.min(36, w * 0.105);
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      var family = 'Figtree, system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif';
      ctx.font = '800 ' + size + 'px ' + family;
      while (size > 14 && ctx.measureText(label).width > w * 0.84) {
        size -= 1;
        ctx.font = '800 ' + size + 'px ' + family;
      }
      ctx.save();
      ctx.shadowColor = 'rgba(110,80,20,0.35)';
      ctx.shadowBlur = 3;
      ctx.shadowOffsetY = 1;
      ctx.fillStyle = 'rgba(255,250,232,0.66)';
      ctx.fillText(label, w / 2, h / 2 + 1);
      ctx.restore();
    }

    /* ---------------------------------------------------------------- one popup */
    function setup(root) {
      if (root.covaPopup) return;
      var card = q(root, 'card');
      var canvas = q(root, 'canvas');
      var reveal = q(root, 'reveal');
      var claimBtn = q(root, 'claim');
      var form = q(root, 'form');
      var email = q(root, 'email');
      var errorLine = q(root, 'error-line');
      var success = q(root, 'success');
      var closeBtn = q(root, 'close');
      if (!card || !canvas || !closeBtn) return;

      var delay = parseFloat(root.getAttribute('data-cova-popup-delay'));
      if (isNaN(delay) || delay < 0) delay = 10;
      var amount = root.getAttribute('data-cova-popup-amount') || '';
      var errorText = root.getAttribute('data-cova-popup-error') || '';
      var closeLabel = root.getAttribute('data-cova-popup-close-label') || '';
      var label = canvas.getAttribute('data-cova-popup-label') || '';
      var ctx = canvas.getContext ? canvas.getContext('2d', { willReadFrequently: true }) : null;

      var st = { open: false, done: false, touched: false, drawing: false, last: null, lastCheck: 0, w: 0, h: 0, dpr: 1, timer: 0, prevFocus: null, claimed: false };

      function prepare() {
        if (!ctx) {
          finish();
          return;
        }
        var rect = card.getBoundingClientRect();
        if (!rect.width) return;
        st.dpr = Math.min(window.devicePixelRatio || 1, 2);
        st.w = Math.round(rect.width);
        st.h = Math.round(rect.height);
        canvas.width = Math.round(st.w * st.dpr);
        canvas.height = Math.round(st.h * st.dpr);
        ctx.setTransform(st.dpr, 0, 0, st.dpr, 0, 0);
        ctx.clearRect(0, 0, st.w, st.h);
        paintCoating(ctx, st.w, st.h, label);
        st.touched = false;
      }

      function point(e) {
        var r = canvas.getBoundingClientRect();
        return { x: ((e.clientX - r.left) / r.width) * st.w, y: ((e.clientY - r.top) / r.height) * st.h };
      }
      function stroke(from, to) {
        ctx.globalCompositeOperation = 'destination-out';
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.lineWidth = BRUSH;
        ctx.beginPath();
        ctx.moveTo(from.x, from.y);
        ctx.lineTo(to.x, to.y);
        ctx.stroke();
        ctx.globalCompositeOperation = 'source-over';
      }
      function cleared() {
        var cw = canvas.width;
        var ch = canvas.height;
        var data;
        try {
          data = ctx.getImageData(0, 0, cw, ch).data;
        } catch (e) {
          return 0;
        }
        var step = Math.max(4, Math.round(st.dpr * 4));
        var total = 0;
        var gone = 0;
        for (var y = 0; y < ch; y += step) {
          for (var x = 0; x < cw; x += step) {
            total++;
            if (data[(y * cw + x) * 4 + 3] < 40) gone++;
          }
        }
        return total ? gone / total : 0;
      }
      function check() {
        st.lastCheck = Date.now();
        if (!st.done && cleared() >= THRESHOLD) finish();
      }

      function finish() {
        if (st.done) return;
        st.done = true;
        st.drawing = false;
        canvas.classList.add('is-cleared');
        canvas.setAttribute('aria-hidden', 'true');
        canvas.tabIndex = -1;
        if (reveal) {
          reveal.hidden = false;
          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
              reveal.classList.add('is-shown');
            });
          });
        }
      }

      canvas.addEventListener('pointerdown', function (e) {
        if (st.done || !ctx) return;
        e.preventDefault();
        try {
          canvas.setPointerCapture(e.pointerId);
        } catch (err) {}
        st.drawing = true;
        st.touched = true;
        st.last = point(e);
        stroke(st.last, st.last);
      });
      canvas.addEventListener('pointermove', function (e) {
        if (!st.drawing || st.done) return;
        e.preventDefault();
        var p = point(e);
        stroke(st.last, p);
        st.last = p;
        if (Date.now() - st.lastCheck > 90) check();
      });
      function stop() {
        if (!st.drawing) return;
        st.drawing = false;
        check();
      }
      canvas.addEventListener('pointerup', stop);
      canvas.addEventListener('pointercancel', stop);
      canvas.addEventListener('lostpointercapture', stop);
      canvas.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (ctx) ctx.clearRect(0, 0, st.w, st.h);
          finish();
        }
      });

      if (claimBtn && form) {
        claimBtn.addEventListener('click', function () {
          claimBtn.hidden = true;
          form.hidden = false;
          if (email) email.focus();
        });
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var value = (email ? email.value : '').trim();
          if (!EMAIL_RE.test(value)) {
            if (errorLine) {
              errorLine.textContent = errorText;
              errorLine.hidden = false;
            }
            if (email) {
              email.setAttribute('aria-invalid', 'true');
              email.focus();
            }
            return;
          }
          if (errorLine) errorLine.hidden = true;
          if (email) email.removeAttribute('aria-invalid');
          st.claimed = true;
          form.hidden = true;
          if (success) success.hidden = false;
          if (closeLabel) closeBtn.textContent = closeLabel;
          // The email is sent by a separate integration that listens for this event.
          root.dispatchEvent(new CustomEvent('cova:discount-claimed', { bubbles: true, detail: { email: value, discount: amount, source: 'scratch-popup' } }));
        });
        if (email) {
          email.addEventListener('input', function () {
            if (errorLine) errorLine.hidden = true;
            email.removeAttribute('aria-invalid');
          });
        }
      }

      function focusables() {
        return Array.prototype.slice.call(root.querySelectorAll('button, input, [tabindex="0"]')).filter(function (el) {
          return !el.disabled && !el.hidden && !el.closest('[hidden]') && el.getAttribute('aria-hidden') !== 'true' && el.tabIndex >= 0;
        });
      }
      function onKey(e) {
        if (!st.open) return;
        if (e.key === 'Escape') {
          e.preventDefault();
          close();
          return;
        }
        if (e.key !== 'Tab') return;
        var list = focusables();
        if (!list.length) return;
        var first = list[0];
        var last = list[list.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === root)) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
      var resizeRaf = 0;
      function onResize() {
        if (!st.open || st.touched || st.done) return;
        if (resizeRaf) return;
        resizeRaf = window.requestAnimationFrame(function () {
          resizeRaf = 0;
          prepare();
        });
      }

      function open(opts) {
        if (st.open) return;
        opts = opts || {};
        st.open = true;
        window.clearTimeout(st.timer);
        st.prevFocus = document.activeElement;
        root.hidden = false;
        document.documentElement.classList.add('cova-popup-lock');
        if (!opts.preview) storageSet(SEEN_KEY, '1');
        // make sure the label font is ready before the coating is painted
        var ready = document.fonts && document.fonts.load ? document.fonts.load('800 36px Figtree') : null;
        var go = function () {
          if (st.open && !st.touched && !st.done) prepare();
        };
        prepare();
        if (ready && ready.then) ready.then(go, go);
        window.requestAnimationFrame(function () {
          root.classList.add('is-open');
        });
        try {
          root.focus({ preventScroll: true });
        } catch (e) {
          root.focus();
        }
        document.addEventListener('keydown', onKey);
        window.addEventListener('resize', onResize);
        root.dispatchEvent(new CustomEvent('cova:popup-open', { bubbles: true }));
      }

      function close() {
        if (!st.open) return;
        st.open = false;
        root.classList.remove('is-open');
        document.removeEventListener('keydown', onKey);
        window.removeEventListener('resize', onResize);
        var hide = function () {
          if (st.open) return;
          root.hidden = true;
          document.documentElement.classList.remove('cova-popup-lock');
        };
        if (reduceMotion()) hide();
        else window.setTimeout(hide, 360);
        var back = st.prevFocus;
        if (back && back.focus && document.contains(back)) {
          try {
            back.focus({ preventScroll: true });
          } catch (e) {}
        }
        root.dispatchEvent(new CustomEvent('cova:popup-close', { bubbles: true, detail: { claimed: st.claimed } }));
      }

      closeBtn.addEventListener('click', close);

      function schedule() {
        if (designMode()) return; // in the theme editor the popup opens when the section is selected
        if (blocked() || storageGet(SEEN_KEY)) return;
        st.timer = window.setTimeout(function () {
          if (blocked() || storageGet(SEEN_KEY)) return;
          open();
        }, delay * 1000);
      }
      schedule();

      root.covaPopup = { open: open, close: close };
    }

    function init(scope) {
      var list = (scope || document).querySelectorAll('[data-cova-popup]');
      for (var i = 0; i < list.length; i++) setup(list[i]);
    }

    window.CovaPopup = { init: init };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:section:select', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('[data-cova-popup]') : null;
      if (root && root.covaPopup) root.covaPopup.open({ preview: true });
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('[data-cova-popup]') : null;
      if (root && root.covaPopup) root.covaPopup.close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sewing-machine-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.CovaVideoInit) return;
    window.CovaVideoInit = true;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-cova-video-play]') : null;
      if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
      var frame = btn.closest('[data-cova-video]');
      if (!frame) return;
      var video = frame.querySelector('video');
      var embed = frame.getAttribute('data-embed');
      if (video) {
        video.controls = true;
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
        frame.classList.add('is-playing');
      } else if (embed) {
        var stage = frame.querySelector('[data-cova-video-stage]');
        if (!stage) return;
        var frameEl = document.createElement('iframe');
        frameEl.src = embed;
        frameEl.allow = 'autoplay; fullscreen; picture-in-picture';
        frameEl.setAttribute('allowfullscreen', '');
        frameEl.title = btn.getAttribute('aria-label') || 'Video';
        stage.appendChild(frameEl);
        frame.classList.add('is-playing');
      }
    });

    // when a video ends, show the poster and play button again
    document.addEventListener(
      'ended',
      function (e) {
        var frame = e.target.closest ? e.target.closest('[data-cova-video]') : null;
        if (!frame) return;
        e.target.controls = false;
        frame.classList.remove('is-playing');
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["y2k-camera-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    if (window.CovaHeroGallery) return;

    function initGallery(root) {
      if (root.dataset.covaGalleryInit) return;
      var track = root.querySelector('[data-cova-gallery-track]');
      var list = root.querySelector('[data-cova-gallery-list]');
      var wrap = root.querySelector('[data-cova-gallery-thumbs]');
      if (!track || !list || !wrap) return;
      root.dataset.covaGalleryInit = '1';
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-cova-gallery-thumb]'));
      var clamp = root.hasAttribute('data-cova-gallery-clamp');
      var reduce = false;
      try {
        reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) {}
      var active = -1;
      var raf = 0;

      function pitch() {
        if (thumbs.length > 1) return thumbs[1].parentElement.offsetTop - thumbs[0].parentElement.offsetTop;
        return thumbs[0] ? thumbs[0].offsetHeight : 0;
      }
      function update() {
        raf = 0;
        var w = track.clientWidth || 1;
        var count = thumbs.length;
        var p = Math.max(0, Math.min(count - 1, track.scrollLeft / w));
        var shift = p * pitch();
        if (clamp) shift = Math.min(shift, Math.max(0, list.offsetHeight - wrap.clientHeight));
        list.style.transform = 'translate3d(0,' + -shift.toFixed(2) + 'px,0)';
        var i = Math.round(p);
        if (i !== active) {
          active = i;
          thumbs.forEach(function (t, n) {
            var on = n === i;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-current', on ? 'true' : 'false');
          });
        }
      }
      function queue() {
        if (!raf) raf = window.requestAnimationFrame(update);
      }
      function goTo(i) {
        track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      }

      track.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue);
      thumbs.forEach(function (t, n) {
        t.addEventListener('click', function () {
          goTo(n);
        });
      });
      if (window.ResizeObserver) new window.ResizeObserver(queue).observe(root);
      update();
    }

    function init(scope) {
      (scope || document).querySelectorAll('[data-cova-gallery]').forEach(initGallery);
    }
    window.CovaHeroGallery = { init: init };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["y2k-camera-problem-checklist"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.CovaFlashGridInit) return;
    window.CovaFlashGridInit = true;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function setup(root) {
      var list = (root || document).querySelectorAll('[data-cova-flash-grid]:not([data-cova-flash-ready])');
      Array.prototype.forEach.call(list, function (el) {
        el.setAttribute('data-cova-flash-ready', '');
        if (reduce || !('IntersectionObserver' in window)) return;
        el.classList.add('is-armed');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            io.disconnect();
            el.classList.add('is-playing');
          });
        }, { threshold: 0.55 });
        io.observe(el);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setup(); });
    else setup();
    document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["y2k-camera-proven-stats"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.CovaStatsCountInit) return;
    window.CovaStatsCountInit = true;

    var DURATION = 1400; // ms, ease-out
    var STAGGER = 140; // ms between the cards
    var reduceMq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    function esc(t) {
      return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    // "93%" -> prefix "", number "93", suffix "%". Anything else (no number, thousands separators) stays as is.
    function parse(text) {
      var m = /^(\D*?)(\d+(?:\.\d+)?)(\D*)$/.exec(text);
      if (!m) return null;
      var dot = m[2].indexOf('.');
      return { pre: m[1], post: m[3], value: parseFloat(m[2]), decimals: dot < 0 ? 0 : m[2].length - dot - 1 };
    }

    // Pin the box to the width of the final text (so nothing around it can move), then show the start value.
    function prepare(el) {
      var finalText = el.textContent.trim();
      var info = parse(finalText);
      if (!info) return null;
      el.style.minWidth = Math.ceil(el.getBoundingClientRect().width * 100) / 100 + 'px';
      el.innerHTML = '<span class="cova-visually-hidden">' + esc(finalText) + '</span><span aria-hidden="true"></span>';
      var job = { el: el, text: el.lastChild, finalText: finalText, info: info };
      show(job, 0);
      return job;
    }

    function show(job, value) {
      job.text.textContent = job.info.pre + value.toFixed(job.info.decimals) + job.info.post;
    }

    function run(jobs) {
      var t0 = null;
      function frame(now) {
        if (t0 === null) t0 = now;
        var running = false;
        for (var i = 0; i < jobs.length; i++) {
          var job = jobs[i];
          if (job.done) continue;
          var p = (now - t0 - i * STAGGER) / DURATION;
          if (p >= 1) {
            job.done = true;
            job.el.textContent = job.finalText; // the text exactly as authored in the setting
            continue;
          }
          running = true;
          p = p < 0 ? 0 : p;
          show(job, job.info.value * (1 - Math.pow(1 - p, 3)));
        }
        if (running) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    function arm(root) {
      var sections = (root || document).querySelectorAll('[data-cova-proven-stats]');
      Array.prototype.forEach.call(sections, function (section) {
        if (section.getAttribute('data-cova-count-state')) return;
        section.setAttribute('data-cova-count-state', 'armed');
        if ((reduceMq && reduceMq.matches) || !('IntersectionObserver' in window)) return;
        var els = section.querySelectorAll('[data-cova-count]');
        if (!els.length) return;
        var fontsReady = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
        var jobs = null;
        var seen = false;
        fontsReady.then(function () {
          // measure once the font is loaded, then park every number at 0 until the section is seen
          jobs = [];
          Array.prototype.forEach.call(els, function (el) {
            var job = prepare(el);
            if (job) jobs.push(job);
          });
          if (seen && jobs.length) run(jobs);
        });
        var io = new IntersectionObserver(
          function (entries) {
            for (var i = 0; i < entries.length; i++) {
              if (!entries[i].isIntersecting) continue;
              io.disconnect();
              seen = true;
              if (jobs && jobs.length) run(jobs);
              break;
            }
          },
          { threshold: 0.3 }
        );
        io.observe(section);
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { arm(); });
    else arm();
    document.addEventListener('shopify:section:load', function (e) { arm(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["y2k-camera-scratch-popup"]) return;
  try {
    
  (function () {
    'use strict';
    if (window.CovaPopup) {
      window.CovaPopup.init(document);
      return;
    }

    var SEEN_KEY = 'cova:popup-seen';
    var BRUSH = 46; // scratch brush width in CSS px
    var THRESHOLD = 0.5; // share of the coating that has to go before the prize is revealed
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    function storageGet(key) {
      try {
        return window.localStorage.getItem(key);
      } catch (e) {
        return null;
      }
    }
    function storageSet(key, value) {
      try {
        window.localStorage.setItem(key, value);
      } catch (e) {}
    }
    function blocked() {
      var html = document.documentElement;
      return html.hasAttribute('data-cova-no-popup') || (document.body && document.body.hasAttribute('data-cova-no-popup'));
    }
    function designMode() {
      return !!(window.Shopify && window.Shopify.designMode);
    }
    function q(root, name) {
      return root.querySelector('[data-cova-popup-' + name + ']');
    }
    function reduceMotion() {
      try {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) {
        return false;
      }
    }

    /* ---------------------------------------------------------------- gold coating */
    function roundRect(ctx, x, y, w, h, r) {
      ctx.beginPath();
      ctx.moveTo(x + r, y);
      ctx.arcTo(x + w, y, x + w, y + h, r);
      ctx.arcTo(x + w, y + h, x, y + h, r);
      ctx.arcTo(x, y + h, x, y, r);
      ctx.arcTo(x, y, x + w, y, r);
      ctx.closePath();
    }

    function paintCoating(ctx, w, h, label) {
      ctx.globalCompositeOperation = 'source-over';
      var g = ctx.createLinearGradient(0, 0, w, h);
      g.addColorStop(0, '#f6d982');
      g.addColorStop(0.28, '#e4bc5d');
      g.addColorStop(0.5, '#f3d47c');
      g.addColorStop(0.74, '#d6aa45');
      g.addColorStop(1, '#ebc869');
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, w, h);

      // soft light sweep, like foil catching light
      var sweep = ctx.createLinearGradient(0, h * 0.15, w, h * 0.05);
      sweep.addColorStop(0, 'rgba(255,255,255,0)');
      sweep.addColorStop(0.5, 'rgba(255,255,255,0.22)');
      sweep.addColorStop(1, 'rgba(255,255,255,0)');
      ctx.fillStyle = sweep;
      ctx.fillRect(0, 0, w, h * 0.6);

      // fine grain
      var specks = Math.round((w * h) / 48);
      for (var i = 0; i < specks; i++) {
        var x = Math.random() * w;
        var y = Math.random() * h;
        var dark = Math.random() < 0.45;
        ctx.fillStyle = dark ? 'rgba(120,86,20,' + (0.04 + Math.random() * 0.1) + ')' : 'rgba(255,248,214,' + (0.08 + Math.random() * 0.2) + ')';
        var s = 0.5 + Math.random() * 1.3;
        ctx.fillRect(x, y, s, s);
      }

      // darker brush strokes behind the label
      ctx.save();
      ctx.globalAlpha = 0.17;
      ctx.fillStyle = '#6d5220';
      for (var k = 0; k < 5; k++) {
        ctx.save();
        ctx.translate(w * (0.2 + 0.15 * k), h * 0.56);
        ctx.rotate(-0.3);
        roundRect(ctx, -w * 0.045, -h * 0.27, w * 0.095, h * 0.54, w * 0.02);
        ctx.fill();
        ctx.restore();
      }
      ctx.restore();

      // label
      var size = Math.min(36, w * 0.105);
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      var family = 'Figtree, system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif';
      ctx.font = '800 ' + size + 'px ' + family;
      while (size > 14 && ctx.measureText(label).width > w * 0.84) {
        size -= 1;
        ctx.font = '800 ' + size + 'px ' + family;
      }
      ctx.save();
      ctx.shadowColor = 'rgba(110,80,20,0.35)';
      ctx.shadowBlur = 3;
      ctx.shadowOffsetY = 1;
      ctx.fillStyle = 'rgba(255,250,232,0.66)';
      ctx.fillText(label, w / 2, h / 2 + 1);
      ctx.restore();
    }

    /* ---------------------------------------------------------------- one popup */
    function setup(root) {
      if (root.covaPopup) return;
      var card = q(root, 'card');
      var canvas = q(root, 'canvas');
      var reveal = q(root, 'reveal');
      var claimBtn = q(root, 'claim');
      var form = q(root, 'form');
      var email = q(root, 'email');
      var errorLine = q(root, 'error-line');
      var success = q(root, 'success');
      var closeBtn = q(root, 'close');
      if (!card || !canvas || !closeBtn) return;

      var delay = parseFloat(root.getAttribute('data-cova-popup-delay'));
      if (isNaN(delay) || delay < 0) delay = 10;
      var amount = root.getAttribute('data-cova-popup-amount') || '';
      var errorText = root.getAttribute('data-cova-popup-error') || '';
      var closeLabel = root.getAttribute('data-cova-popup-close-label') || '';
      var label = canvas.getAttribute('data-cova-popup-label') || '';
      var ctx = canvas.getContext ? canvas.getContext('2d', { willReadFrequently: true }) : null;

      var st = { open: false, done: false, touched: false, drawing: false, last: null, lastCheck: 0, w: 0, h: 0, dpr: 1, timer: 0, prevFocus: null, claimed: false };

      function prepare() {
        if (!ctx) {
          finish();
          return;
        }
        var rect = card.getBoundingClientRect();
        if (!rect.width) return;
        st.dpr = Math.min(window.devicePixelRatio || 1, 2);
        st.w = Math.round(rect.width);
        st.h = Math.round(rect.height);
        canvas.width = Math.round(st.w * st.dpr);
        canvas.height = Math.round(st.h * st.dpr);
        ctx.setTransform(st.dpr, 0, 0, st.dpr, 0, 0);
        ctx.clearRect(0, 0, st.w, st.h);
        paintCoating(ctx, st.w, st.h, label);
        st.touched = false;
      }

      function point(e) {
        var r = canvas.getBoundingClientRect();
        return { x: ((e.clientX - r.left) / r.width) * st.w, y: ((e.clientY - r.top) / r.height) * st.h };
      }
      function stroke(from, to) {
        ctx.globalCompositeOperation = 'destination-out';
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.lineWidth = BRUSH;
        ctx.beginPath();
        ctx.moveTo(from.x, from.y);
        ctx.lineTo(to.x, to.y);
        ctx.stroke();
        ctx.globalCompositeOperation = 'source-over';
      }
      function cleared() {
        var cw = canvas.width;
        var ch = canvas.height;
        var data;
        try {
          data = ctx.getImageData(0, 0, cw, ch).data;
        } catch (e) {
          return 0;
        }
        var step = Math.max(4, Math.round(st.dpr * 4));
        var total = 0;
        var gone = 0;
        for (var y = 0; y < ch; y += step) {
          for (var x = 0; x < cw; x += step) {
            total++;
            if (data[(y * cw + x) * 4 + 3] < 40) gone++;
          }
        }
        return total ? gone / total : 0;
      }
      function check() {
        st.lastCheck = Date.now();
        if (!st.done && cleared() >= THRESHOLD) finish();
      }

      function finish() {
        if (st.done) return;
        st.done = true;
        st.drawing = false;
        canvas.classList.add('is-cleared');
        canvas.setAttribute('aria-hidden', 'true');
        canvas.tabIndex = -1;
        if (reveal) {
          reveal.hidden = false;
          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
              reveal.classList.add('is-shown');
            });
          });
        }
      }

      canvas.addEventListener('pointerdown', function (e) {
        if (st.done || !ctx) return;
        e.preventDefault();
        try {
          canvas.setPointerCapture(e.pointerId);
        } catch (err) {}
        st.drawing = true;
        st.touched = true;
        st.last = point(e);
        stroke(st.last, st.last);
      });
      canvas.addEventListener('pointermove', function (e) {
        if (!st.drawing || st.done) return;
        e.preventDefault();
        var p = point(e);
        stroke(st.last, p);
        st.last = p;
        if (Date.now() - st.lastCheck > 90) check();
      });
      function stop() {
        if (!st.drawing) return;
        st.drawing = false;
        check();
      }
      canvas.addEventListener('pointerup', stop);
      canvas.addEventListener('pointercancel', stop);
      canvas.addEventListener('lostpointercapture', stop);
      canvas.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (ctx) ctx.clearRect(0, 0, st.w, st.h);
          finish();
        }
      });

      if (claimBtn && form) {
        claimBtn.addEventListener('click', function () {
          claimBtn.hidden = true;
          form.hidden = false;
          if (email) email.focus();
        });
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var value = (email ? email.value : '').trim();
          if (!EMAIL_RE.test(value)) {
            if (errorLine) {
              errorLine.textContent = errorText;
              errorLine.hidden = false;
            }
            if (email) {
              email.setAttribute('aria-invalid', 'true');
              email.focus();
            }
            return;
          }
          if (errorLine) errorLine.hidden = true;
          if (email) email.removeAttribute('aria-invalid');
          st.claimed = true;
          form.hidden = true;
          if (success) success.hidden = false;
          if (closeLabel) closeBtn.textContent = closeLabel;
          // The email is sent by a separate integration that listens for this event.
          root.dispatchEvent(new CustomEvent('cova:discount-claimed', { bubbles: true, detail: { email: value, discount: amount, source: 'scratch-popup' } }));
        });
        if (email) {
          email.addEventListener('input', function () {
            if (errorLine) errorLine.hidden = true;
            email.removeAttribute('aria-invalid');
          });
        }
      }

      function focusables() {
        return Array.prototype.slice.call(root.querySelectorAll('button, input, [tabindex="0"]')).filter(function (el) {
          return !el.disabled && !el.hidden && !el.closest('[hidden]') && el.getAttribute('aria-hidden') !== 'true' && el.tabIndex >= 0;
        });
      }
      function onKey(e) {
        if (!st.open) return;
        if (e.key === 'Escape') {
          e.preventDefault();
          close();
          return;
        }
        if (e.key !== 'Tab') return;
        var list = focusables();
        if (!list.length) return;
        var first = list[0];
        var last = list[list.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === root)) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
      var resizeRaf = 0;
      function onResize() {
        if (!st.open || st.touched || st.done) return;
        if (resizeRaf) return;
        resizeRaf = window.requestAnimationFrame(function () {
          resizeRaf = 0;
          prepare();
        });
      }

      function open(opts) {
        if (st.open) return;
        opts = opts || {};
        st.open = true;
        window.clearTimeout(st.timer);
        st.prevFocus = document.activeElement;
        root.hidden = false;
        document.documentElement.classList.add('cova-popup-lock');
        if (!opts.preview) storageSet(SEEN_KEY, '1');
        // make sure the label font is ready before the coating is painted
        var ready = document.fonts && document.fonts.load ? document.fonts.load('800 36px Figtree') : null;
        var go = function () {
          if (st.open && !st.touched && !st.done) prepare();
        };
        prepare();
        if (ready && ready.then) ready.then(go, go);
        window.requestAnimationFrame(function () {
          root.classList.add('is-open');
        });
        try {
          root.focus({ preventScroll: true });
        } catch (e) {
          root.focus();
        }
        document.addEventListener('keydown', onKey);
        window.addEventListener('resize', onResize);
        root.dispatchEvent(new CustomEvent('cova:popup-open', { bubbles: true }));
      }

      function close() {
        if (!st.open) return;
        st.open = false;
        root.classList.remove('is-open');
        document.removeEventListener('keydown', onKey);
        window.removeEventListener('resize', onResize);
        var hide = function () {
          if (st.open) return;
          root.hidden = true;
          document.documentElement.classList.remove('cova-popup-lock');
        };
        if (reduceMotion()) hide();
        else window.setTimeout(hide, 360);
        var back = st.prevFocus;
        if (back && back.focus && document.contains(back)) {
          try {
            back.focus({ preventScroll: true });
          } catch (e) {}
        }
        root.dispatchEvent(new CustomEvent('cova:popup-close', { bubbles: true, detail: { claimed: st.claimed } }));
      }

      closeBtn.addEventListener('click', close);

      function schedule() {
        if (designMode()) return; // in the theme editor the popup opens when the section is selected
        if (blocked() || storageGet(SEEN_KEY)) return;
        st.timer = window.setTimeout(function () {
          if (blocked() || storageGet(SEEN_KEY)) return;
          open();
        }, delay * 1000);
      }
      schedule();

      root.covaPopup = { open: open, close: close };
    }

    function init(scope) {
      var list = (scope || document).querySelectorAll('[data-cova-popup]');
      for (var i = 0; i < list.length; i++) setup(list[i]);
    }

    window.CovaPopup = { init: init };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:section:select', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('[data-cova-popup]') : null;
      if (root && root.covaPopup) root.covaPopup.open({ preview: true });
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('[data-cova-popup]') : null;
      if (root && root.covaPopup) root.covaPopup.close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["y2k-camera-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.CovaVideoInit) return;
    window.CovaVideoInit = true;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-cova-video-play]') : null;
      if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
      var frame = btn.closest('[data-cova-video]');
      if (!frame) return;
      var video = frame.querySelector('video');
      var embed = frame.getAttribute('data-embed');
      if (video) {
        video.controls = true;
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
        frame.classList.add('is-playing');
      } else if (embed) {
        var stage = frame.querySelector('[data-cova-video-stage]');
        if (!stage) return;
        var frameEl = document.createElement('iframe');
        frameEl.src = embed;
        frameEl.allow = 'autoplay; fullscreen; picture-in-picture';
        frameEl.setAttribute('allowfullscreen', '');
        frameEl.title = btn.getAttribute('aria-label') || 'Video';
        stage.appendChild(frameEl);
        frame.classList.add('is-playing');
      }
    });

    // when a video ends, show the poster and play button again
    document.addEventListener(
      'ended',
      function (e) {
        var frame = e.target.closest ? e.target.closest('[data-cova-video]') : null;
        if (!frame) return;
        e.target.controls = false;
        frame.classList.remove('is-playing');
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
